var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignsexecutedcorrectly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 161.032,
    height: 141.116,
    viewBox: "0 0 161.032 141.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7279",
    "data-name": "Caminho 7279",
    d: "M1576.107,171.309c-24.02.866-26.087-6.145-51.867-17.317s-60.386,13.407-53.152,41.9-12.932,62.006,14.468,75.971,81.055,26.255,108.427,0S1638.113,169.074,1576.107,171.309Z",
    transform: "translate(-1470.114 -151.237)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.001,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9c4ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#ced6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#e8edf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#f7fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdffff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009db0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#01c0ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#01dade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.806,
    stopColor: "#02e9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02efee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.005,
    y1: 0.499,
    x2: 1.001,
    y2: 0.499,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.006,
    y1: 0.511,
    x2: 1.003,
    y2: 0.511,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.013,
    y1: 0.496,
    x2: 1.015,
    y2: 0.496,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.003,
    y1: 0.497,
    x2: 1.013,
    y2: 0.497,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb2040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#f53d5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#ef5772"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#ec6680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6c85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1.104,
    y1: 1.376,
    x2: -0.24,
    y2: 0.605,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.154,
    y1: 1.027,
    x2: 0.958,
    y2: 1.027,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3934c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.272,
    stopColor: "#3f39c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618,
    stopColor: "#4e47d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#685eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 3.837,
    y1: 20.873,
    x2: 4.829,
    y2: 20.873,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb6c85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#ed7281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f18176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    stopColor: "#f99b63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 3.79,
    y1: 20.284,
    x2: 4.782,
    y2: 20.284,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_642",
    "data-name": "Elipse 642",
    cx: 3.743,
    cy: 3.743,
    r: 3.743
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_647",
    "data-name": "Elipse 647",
    cx: 3.715,
    cy: 3.715,
    r: 3.715
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7422",
    "data-name": "Caminho 7422",
    d: "M1643.668,328.415l5.67-.894,24.774,12.122,15.725-1.006-14.719-56.811,8.044-5.167,3.464-15.948,8.044-5.447V250.6l6.592-1.648-6.592-15.278-12.4,1.4-10.781-8.77-17.429,4.944-4.385,18.323-12.373,23.8,6.061,17.457Z",
    transform: "translate(-1637.3 -226.3)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.118,
    y1: 0.486,
    x2: 0.905,
    y2: 0.525,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.003,
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -0.002,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.005,
    y1: 0.499,
    x2: 1.003,
    y2: 0.499,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.001,
    y1: 0.497,
    x2: 0.998,
    y2: 0.497,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.008,
    y1: 0.507,
    x2: 1.008,
    y2: 0.507,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -0.652,
    y1: -0.879,
    x2: 1.592,
    y2: -0.84,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -0.421,
    y1: -1.864,
    x2: 2.382,
    y2: -2.294,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -0.308,
    y1: -2.889,
    x2: 3.888,
    y2: -3.499,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0.062,
    y1: 0.456,
    x2: 3.083,
    y2: 0.72,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217,
    stopColor: "#f7fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#e8edf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#ced6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b9c4ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0,
    y1: 0.498,
    x2: 1,
    y2: 0.498,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.01,
    y1: 0.5,
    x2: 1.003,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.001,
    y1: 0.499,
    x2: 0.999,
    y2: 0.499,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -0.001,
    y1: 0.501,
    x2: 0.998,
    y2: 0.501,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.001,
    y1: 0.496,
    x2: 1.002,
    y2: 0.496,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0,
    y1: 0.501,
    x2: 1.001,
    y2: 0.501,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.002,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0,
    y1: 0.5,
    x2: 1.003,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.001,
    y1: 0.498,
    x2: 1,
    y2: 0.498,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -0.003,
    y1: 0.502,
    x2: 0.999,
    y2: 0.502,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.001,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.001,
    y1: 0.501,
    x2: 1.001,
    y2: 0.501,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -0.002,
    y1: 0.5,
    x2: 0.998,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0,
    y1: 0.488,
    x2: 0.999,
    y2: 0.488,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.003,
    y1: 0.492,
    x2: 1.002,
    y2: 0.492,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0,
    y1: 0.497,
    x2: 0.999,
    y2: 0.497,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.002,
    y1: 0.502,
    x2: 1.002,
    y2: 0.502,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -0.001,
    y1: 0.507,
    x2: 0.998,
    y2: 0.507,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.001,
    y1: 0.501,
    x2: 0.999,
    y2: 0.501,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -0.004,
    y1: 0.5,
    x2: 1.001,
    y2: 0.5,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -71.808,
    y1: 3.399,
    x2: -70.494,
    y2: 3.022,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -54.273,
    y1: 8.385,
    x2: -53.249,
    y2: 8.038,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -0.001,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -36.231,
    y1: 5.885,
    x2: -35.178,
    y2: 5.55,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Campaigns_executed_correctly",
    "data-name": "Campaigns executed correctly",
    transform: "translate(-1455.2 -74.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6532",
    "data-name": "Grupo 6532",
    transform: "translate(1459.365 74.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7264",
    "data-name": "Caminho 7264",
    d: "M1576.107,171.309c-24.02.866-26.087-6.145-51.867-17.317s-60.386,13.407-53.152,41.9-12.932,62.006,14.468,75.971,81.055,26.255,108.427,0S1638.113,169.074,1576.107,171.309Z",
    transform: "translate(-1470.114 -146.719)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6531",
    "data-name": "Grupo 6531",
    transform: "translate(0 4.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6530",
    "data-name": "Grupo 6530",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6523",
    "data-name": "Grupo 6523",
    transform: "translate(-38.185 14.765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6517",
    "data-name": "Grupo 6517",
    transform: "translate(21.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7265",
    "data-name": "Caminho 7265",
    d: "M1421.848,231.7v-4.776h7.9V204.1h2.206v22.819h8.519V231.7h4.553v95.579H1412.1V231.7Z",
    transform: "translate(-1412.1 -204.1)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1897",
    "data-name": "Ret\\xE2ngulo 1897",
    width: 4.553,
    height: 85.999,
    transform: "translate(0 27.596)",
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6518",
    "data-name": "Grupo 6518",
    transform: "translate(38.461 50.359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1898",
    "data-name": "Ret\\xE2ngulo 1898",
    width: 32.93,
    height: 72.815,
    opacity: 0.22,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1899",
    "data-name": "Ret\\xE2ngulo 1899",
    width: 4.553,
    height: 72.815,
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6519",
    "data-name": "Grupo 6519",
    transform: "translate(125.828 50.359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1900",
    "data-name": "Ret\\xE2ngulo 1900",
    width: 32.93,
    height: 72.815,
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1901",
    "data-name": "Ret\\xE2ngulo 1901",
    width: 4.553,
    height: 72.815,
    fill: "#d6d7f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6520",
    "data-name": "Grupo 6520",
    transform: "translate(70.469 15.725)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1902",
    "data-name": "Ret\\xE2ngulo 1902",
    width: 44.158,
    height: 107.449,
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1903",
    "data-name": "Ret\\xE2ngulo 1903",
    width: 4.553,
    height: 107.449,
    fill: "#d6d7f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1904",
    "data-name": "Ret\\xE2ngulo 1904",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 5.139)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1905",
    "data-name": "Ret\\xE2ngulo 1905",
    width: 6.899,
    height: 2.877,
    transform: "translate(21.004 5.139)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1906",
    "data-name": "Ret\\xE2ngulo 1906",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 15.557)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1907",
    "data-name": "Ret\\xE2ngulo 1907",
    width: 6.899,
    height: 2.877,
    transform: "translate(21.004 15.557)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1908",
    "data-name": "Ret\\xE2ngulo 1908",
    width: 6.899,
    height: 2.877,
    transform: "translate(9.385 15.557)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1909",
    "data-name": "Ret\\xE2ngulo 1909",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 25.976)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1910",
    "data-name": "Ret\\xE2ngulo 1910",
    width: 6.899,
    height: 2.877,
    transform: "translate(9.385 25.976)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1911",
    "data-name": "Ret\\xE2ngulo 1911",
    width: 6.899,
    height: 2.877,
    transform: "translate(21.004 31.199)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1912",
    "data-name": "Ret\\xE2ngulo 1912",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 36.422)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1913",
    "data-name": "Ret\\xE2ngulo 1913",
    width: 6.899,
    height: 2.877,
    transform: "translate(21.004 41.617)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1914",
    "data-name": "Ret\\xE2ngulo 1914",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 46.84)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1915",
    "data-name": "Ret\\xE2ngulo 1915",
    width: 6.899,
    height: 2.877,
    transform: "translate(9.385 46.84)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1916",
    "data-name": "Ret\\xE2ngulo 1916",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 56.476)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1917",
    "data-name": "Ret\\xE2ngulo 1917",
    width: 6.899,
    height: 2.877,
    transform: "translate(21.004 56.476)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1918",
    "data-name": "Ret\\xE2ngulo 1918",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 66.894)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1919",
    "data-name": "Ret\\xE2ngulo 1919",
    width: 6.899,
    height: 2.877,
    transform: "translate(21.004 66.894)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1920",
    "data-name": "Ret\\xE2ngulo 1920",
    width: 6.899,
    height: 2.877,
    transform: "translate(9.385 66.894)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1921",
    "data-name": "Ret\\xE2ngulo 1921",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 77.312)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1922",
    "data-name": "Ret\\xE2ngulo 1922",
    width: 6.899,
    height: 2.877,
    transform: "translate(9.385 77.312)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1923",
    "data-name": "Ret\\xE2ngulo 1923",
    width: 6.899,
    height: 2.877,
    transform: "translate(21.004 82.535)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1924",
    "data-name": "Ret\\xE2ngulo 1924",
    width: 6.899,
    height: 2.877,
    transform: "translate(9.385 82.535)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1925",
    "data-name": "Ret\\xE2ngulo 1925",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 87.73)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1926",
    "data-name": "Ret\\xE2ngulo 1926",
    width: 6.899,
    height: 2.877,
    transform: "translate(21.004 92.953)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1927",
    "data-name": "Ret\\xE2ngulo 1927",
    width: 6.899,
    height: 2.877,
    transform: "translate(32.595 98.176)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1928",
    "data-name": "Ret\\xE2ngulo 1928",
    width: 6.899,
    height: 2.877,
    transform: "translate(9.385 98.176)",
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6521",
    "data-name": "Grupo 6521",
    transform: "translate(148.507 23.713)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1929",
    "data-name": "Ret\\xE2ngulo 1929",
    width: 43.293,
    height: 99.433,
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1930",
    "data-name": "Ret\\xE2ngulo 1930",
    width: 4.469,
    height: 99.433,
    fill: "#d6d7f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1931",
    "data-name": "Ret\\xE2ngulo 1931",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 4.776)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1932",
    "data-name": "Ret\\xE2ngulo 1932",
    width: 6.759,
    height: 2.653,
    transform: "translate(20.585 4.776)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1933",
    "data-name": "Ret\\xE2ngulo 1933",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 14.412)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1934",
    "data-name": "Ret\\xE2ngulo 1934",
    width: 6.759,
    height: 2.653,
    transform: "translate(20.585 14.412)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1935",
    "data-name": "Ret\\xE2ngulo 1935",
    width: 6.759,
    height: 2.653,
    transform: "translate(9.189 14.412)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1936",
    "data-name": "Ret\\xE2ngulo 1936",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 24.076)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1937",
    "data-name": "Ret\\xE2ngulo 1937",
    width: 6.759,
    height: 2.653,
    transform: "translate(9.189 24.076)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1938",
    "data-name": "Ret\\xE2ngulo 1938",
    width: 6.759,
    height: 2.653,
    transform: "translate(20.585 28.88)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1939",
    "data-name": "Ret\\xE2ngulo 1939",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 33.712)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1940",
    "data-name": "Ret\\xE2ngulo 1940",
    width: 6.759,
    height: 2.653,
    transform: "translate(20.585 38.544)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1941",
    "data-name": "Ret\\xE2ngulo 1941",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 43.376)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1942",
    "data-name": "Ret\\xE2ngulo 1942",
    width: 6.759,
    height: 2.653,
    transform: "translate(9.189 43.376)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1943",
    "data-name": "Ret\\xE2ngulo 1943",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 52.286)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1944",
    "data-name": "Ret\\xE2ngulo 1944",
    width: 6.759,
    height: 2.653,
    transform: "translate(20.585 52.286)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1945",
    "data-name": "Ret\\xE2ngulo 1945",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 61.922)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1946",
    "data-name": "Ret\\xE2ngulo 1946",
    width: 6.759,
    height: 2.653,
    transform: "translate(20.585 61.922)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1947",
    "data-name": "Ret\\xE2ngulo 1947",
    width: 6.759,
    height: 2.653,
    transform: "translate(9.189 61.922)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1948",
    "data-name": "Ret\\xE2ngulo 1948",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 71.586)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1949",
    "data-name": "Ret\\xE2ngulo 1949",
    width: 6.759,
    height: 2.653,
    transform: "translate(9.189 71.586)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1950",
    "data-name": "Ret\\xE2ngulo 1950",
    width: 6.759,
    height: 2.653,
    transform: "translate(20.585 76.39)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1951",
    "data-name": "Ret\\xE2ngulo 1951",
    width: 6.759,
    height: 2.653,
    transform: "translate(9.189 76.39)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1952",
    "data-name": "Ret\\xE2ngulo 1952",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 81.222)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1953",
    "data-name": "Ret\\xE2ngulo 1953",
    width: 6.759,
    height: 2.653,
    transform: "translate(20.585 86.054)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1954",
    "data-name": "Ret\\xE2ngulo 1954",
    width: 6.759,
    height: 2.653,
    transform: "translate(31.953 90.859)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1955",
    "data-name": "Ret\\xE2ngulo 1955",
    width: 6.759,
    height: 2.653,
    transform: "translate(9.189 90.859)",
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6522",
    "data-name": "Grupo 6522",
    transform: "translate(0 55.331)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1956",
    "data-name": "Ret\\xE2ngulo 1956",
    width: 27.875,
    height: 67.816,
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1957",
    "data-name": "Ret\\xE2ngulo 1957",
    width: 2.877,
    height: 67.816,
    fill: "#d6d7f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1958",
    "data-name": "Ret\\xE2ngulo 1958",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 3.268)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1959",
    "data-name": "Ret\\xE2ngulo 1959",
    width: 4.357,
    height: 1.815,
    transform: "translate(13.267 3.268)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1960",
    "data-name": "Ret\\xE2ngulo 1960",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 9.832)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1961",
    "data-name": "Ret\\xE2ngulo 1961",
    width: 4.357,
    height: 1.815,
    transform: "translate(13.267 9.832)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1962",
    "data-name": "Ret\\xE2ngulo 1962",
    width: 4.357,
    height: 1.815,
    transform: "translate(5.921 9.832)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1963",
    "data-name": "Ret\\xE2ngulo 1963",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 16.423)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1964",
    "data-name": "Ret\\xE2ngulo 1964",
    width: 4.357,
    height: 1.815,
    transform: "translate(5.921 16.423)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1965",
    "data-name": "Ret\\xE2ngulo 1965",
    width: 4.357,
    height: 1.815,
    transform: "translate(13.267 19.719)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1966",
    "data-name": "Ret\\xE2ngulo 1966",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 22.987)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1967",
    "data-name": "Ret\\xE2ngulo 1967",
    width: 4.357,
    height: 1.815,
    transform: "translate(13.267 26.283)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1968",
    "data-name": "Ret\\xE2ngulo 1968",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 29.579)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1969",
    "data-name": "Ret\\xE2ngulo 1969",
    width: 4.357,
    height: 1.815,
    transform: "translate(5.921 29.579)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1970",
    "data-name": "Ret\\xE2ngulo 1970",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 35.667)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1971",
    "data-name": "Ret\\xE2ngulo 1971",
    width: 4.357,
    height: 1.815,
    transform: "translate(13.267 35.667)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1972",
    "data-name": "Ret\\xE2ngulo 1972",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 42.231)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1973",
    "data-name": "Ret\\xE2ngulo 1973",
    width: 4.357,
    height: 1.815,
    transform: "translate(13.267 42.231)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1974",
    "data-name": "Ret\\xE2ngulo 1974",
    width: 4.357,
    height: 1.815,
    transform: "translate(5.921 42.231)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1975",
    "data-name": "Ret\\xE2ngulo 1975",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 48.823)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1976",
    "data-name": "Ret\\xE2ngulo 1976",
    width: 4.357,
    height: 1.815,
    transform: "translate(5.921 48.823)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1977",
    "data-name": "Ret\\xE2ngulo 1977",
    width: 4.357,
    height: 1.815,
    transform: "translate(13.267 52.119)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1978",
    "data-name": "Ret\\xE2ngulo 1978",
    width: 4.357,
    height: 1.815,
    transform: "translate(5.921 52.119)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1979",
    "data-name": "Ret\\xE2ngulo 1979",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 55.414)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1980",
    "data-name": "Ret\\xE2ngulo 1980",
    width: 4.357,
    height: 1.815,
    transform: "translate(13.267 58.682)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1981",
    "data-name": "Ret\\xE2ngulo 1981",
    width: 4.357,
    height: 1.815,
    transform: "translate(20.585 61.978)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1982",
    "data-name": "Ret\\xE2ngulo 1982",
    width: 4.357,
    height: 1.815,
    transform: "translate(5.921 61.978)",
    fill: "#f5f5ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6528",
    "data-name": "Grupo 6528",
    transform: "translate(-69.747 -17.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6525",
    "data-name": "Grupo 6525",
    transform: "translate(0 1.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6524",
    "data-name": "Grupo 6524"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1983",
    "data-name": "Ret\\xE2ngulo 1983",
    width: 134.207,
    height: 153.004,
    transform: "translate(1.48 1.76)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1984",
    "data-name": "Ret\\xE2ngulo 1984",
    width: 2.933,
    height: 156.747,
    transform: "translate(134.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7266",
    "data-name": "Caminho 7266",
    d: "M1364.218,254.28H1353.8l55.833-148.48h10.418Z",
    transform: "translate(-1316.541 -102.281)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7267",
    "data-name": "Caminho 7267",
    d: "M1311.8,254.28h-5.2l55.833-148.48h5.2Z",
    transform: "translate(-1282.524 -102.281)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7268",
    "data-name": "Caminho 7268",
    d: "M1534.423,295.359H1529.2L1577.073,162.8v10.7Z",
    transform: "translate(-1442.95 -143.36)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1985",
    "data-name": "Ret\\xE2ngulo 1985",
    width: 137.14,
    height: 4.05,
    transform: "translate(0 153.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1986",
    "data-name": "Ret\\xE2ngulo 1986",
    width: 2.933,
    height: 155.155,
    transform: "translate(89.462 0.81)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1987",
    "data-name": "Ret\\xE2ngulo 1987",
    width: 131.246,
    height: 1.229,
    transform: "translate(2.961 151.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1988",
    "data-name": "Ret\\xE2ngulo 1988",
    width: 137.14,
    height: 3.491,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1989",
    "data-name": "Ret\\xE2ngulo 1989",
    width: 131.302,
    height: 1.229,
    transform: "translate(2.933 3.519)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6527",
    "data-name": "Grupo 6527",
    transform: "translate(134.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6526",
    "data-name": "Grupo 6526"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1990",
    "data-name": "Ret\\xE2ngulo 1990",
    width: 134.207,
    height: 153.004,
    transform: "translate(2.179)",
    fill: "#fff",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1991",
    "data-name": "Ret\\xE2ngulo 1991",
    width: 2.933,
    height: 156.747,
    transform: "translate(0 1.257)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1992",
    "data-name": "Ret\\xE2ngulo 1992",
    width: 2.933,
    height: 156.747,
    transform: "translate(134.207 1.257)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7269",
    "data-name": "Caminho 7269",
    d: "M1761.218,254.28H1750.8l55.833-148.48h10.418Z",
    transform: "translate(-1736.863 -101.024)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7270",
    "data-name": "Caminho 7270",
    d: "M1708.823,254.28H1703.6l55.833-148.48h5.223Z",
    transform: "translate(-1702.846 -101.024)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7271",
    "data-name": "Caminho 7271",
    d: "M2014.923,295.359H2009.7L2057.573,162.8v10.7Z",
    transform: "translate(-1923.45 -142.103)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1993",
    "data-name": "Ret\\xE2ngulo 1993",
    width: 2.933,
    height: 155.155,
    transform: "translate(44.745 2.067)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1994",
    "data-name": "Ret\\xE2ngulo 1994",
    width: 137.14,
    height: 4.05,
    transform: "translate(0 154.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1995",
    "data-name": "Ret\\xE2ngulo 1995",
    width: 2.933,
    height: 155.155,
    transform: "translate(89.462 2.067)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1996",
    "data-name": "Ret\\xE2ngulo 1996",
    width: 131.246,
    height: 1.229,
    transform: "translate(2.961 153.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1997",
    "data-name": "Ret\\xE2ngulo 1997",
    width: 137.14,
    height: 3.491,
    transform: "translate(0 1.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1998",
    "data-name": "Ret\\xE2ngulo 1998",
    width: 131.302,
    height: 1.229,
    transform: "translate(2.933 4.776)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1999",
    "data-name": "Ret\\xE2ngulo 1999",
    width: 276.179,
    height: 1.76,
    transform: "translate(0 28.852)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2000",
    "data-name": "Ret\\xE2ngulo 2000",
    width: 276.179,
    height: 1.76,
    transform: "translate(0 75.553)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2001",
    "data-name": "Ret\\xE2ngulo 2001",
    width: 276.179,
    height: 1.76,
    transform: "translate(0 122.225)",
    fill: "#f5f5ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6529",
    "data-name": "Grupo 6529",
    transform: "translate(24.128 -5.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7272",
    "data-name": "Caminho 7272",
    d: "M1601.455,208.255A10.067,10.067,0,0,1,1591.4,198.2h.475a9.58,9.58,0,1,0,19.16,0h.475A10.067,10.067,0,0,1,1601.455,208.255Z",
    transform: "translate(-1581.652 -179.654)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7273",
    "data-name": "Caminho 7273",
    d: "M1594.28,170l-12.68,10.5h27.931Z",
    transform: "translate(-1574.589 -159.33)",
    fill: "#d6d7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7274",
    "data-name": "Caminho 7274",
    d: "M1569.879,202.3,1556.5,245.453h38.935L1582.783,202.3Z",
    transform: "translate(-1556.5 -182.609)",
    opacity: 0.22,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2002",
    "data-name": "Ret\\xE2ngulo 2002",
    width: 1.229,
    height: 13.909,
    transform: "translate(19.105)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7275",
    "data-name": "Caminho 7275",
    d: "M1623.834,179.469H1619.7v-3.017a1.442,1.442,0,0,1,1.452-1.452h1.2a1.442,1.442,0,0,1,1.452,1.452v3.017Z",
    transform: "translate(-1602.048 -162.934)",
    fill: "#f4bf62"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_636",
    "data-name": "Elipse 636",
    cx: 2.402,
    cy: 2.402,
    r: 2.402,
    transform: "translate(17.261 19.133)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7276",
    "data-name": "Caminho 7276",
    d: "M1622.227,211.027a2.06,2.06,0,0,1-1.508-1.145c-.056-.223-.391-.112-.335.084a2.281,2.281,0,0,0,1.732,1.4C1622.339,211.39,1622.451,211.055,1622.227,211.027Z",
    transform: "translate(-1602.536 -187.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7277",
    "data-name": "Caminho 7277",
    d: "M1590.893,170,1576.9,180.5h27.959Z",
    transform: "translate(-1571.202 -159.33)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7278",
    "data-name": "Caminho 7278",
    d: "M1624.172,168h-1.145a.74.74,0,0,1-.726-.726v-1.145a.74.74,0,0,1,.726-.726h1.145a.739.739,0,0,1,.726.726v1.145A.739.739,0,0,1,1624.172,168Z",
    transform: "translate(-1603.922 -156.015)",
    fill: "#d6d7f2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7280",
    "data-name": "Caminho 7280",
    d: "M1756.124,149.317a2.32,2.32,0,0,1-1.787,2.57,31.2,31.2,0,0,1-29.97-9.245C1710.932,128.481,1754.448,136.162,1756.124,149.317Z",
    transform: "translate(-1651.5 -135.062)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6537",
    "data-name": "Grupo 6537",
    transform: "translate(1458.572 163.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6535",
    "data-name": "Grupo 6535",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7281",
    "data-name": "Caminho 7281",
    d: "M1516.148,465.965a4.227,4.227,0,0,0,2.43-.81,19.992,19.992,0,0,1-.363,4.469c-.95,1.536-3.6,4.357-3.436,4.357a8.1,8.1,0,0,0,2.123-.5,17.271,17.271,0,0,1-1.62,2.653c-1.285,1.7-3.1,3.072-3.8,5.167a.089.089,0,0,1-.084.084c-.028.112-.14.2-.251.112-3.463-3.268-4.078-8.267-4.581-12.764a4.982,4.982,0,0,1-.056-.642,13.776,13.776,0,0,0,3.184,2.486c.167.084-2.151-3.631-3.3-5.363a9.589,9.589,0,0,1,.587-3.184,26.929,26.929,0,0,1,3.547-6.061c.056-.084.112-.14.167-.223a9.671,9.671,0,0,0,1.48,2.681,31.34,31.34,0,0,0-.475-4.05c.335-.419.67-.838,1.034-1.257.475-.531,1.033-1.452,1.843-1.341s2.625,3.408,2.877,4.329c.112.391.2.81.279,1.229.028.168.084.363.112.531.307,1.648.475,3.352.614,5l-.168.251C1517.6,464.121,1515.98,465.965,1516.148,465.965Z",
    transform: "translate(-1495.471 -451.767)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7282",
    "data-name": "Caminho 7282",
    d: "M1521.392,475.452a8.31,8.31,0,0,0,4.245-2.458c.2-.168-.056-.475-.223-.307a8.235,8.235,0,0,1-3.994,2.346c.363-2.542.782-5.055,1.285-7.6.056-.251-.335-.307-.391-.056-.67,3.324-1.2,6.7-1.62,10.055a17.159,17.159,0,0,1-2.262-4.525c-.084-.251-.447-.084-.363.14a16.764,16.764,0,0,0,2.43,4.776.154.154,0,0,0,.14.084c-.084.726-.168,1.48-.251,2.207a10.234,10.234,0,0,1-1.676-2.933c-.084-.223-.447-.084-.363.14a10.76,10.76,0,0,0,1.9,3.24c.028.028.056.056.084.056-.251,2.43-.447,4.86-.559,7.318,0,.028-.028.056-.028.084q-.084,1.341-.084,2.681c-.028.587-.028,1.173-.056,1.76a.213.213,0,0,0,.056.14,86.619,86.619,0,0,0,2.067,16.312c.14-.028.251-.056.391-.084a80.647,80.647,0,0,1-2.067-18.462c.028-.67.056-1.313.084-1.983a.131.131,0,0,0,.167-.028,6.154,6.154,0,0,0,1.788-1.816c.14-.2-.168-.447-.307-.251a6.371,6.371,0,0,1-1.648,1.7c.251-4.19.67-8.379,1.257-12.541Z",
    transform: "translate(-1503.871 -462.901)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7283",
    "data-name": "Caminho 7283",
    d: "M1471.246,508.26a4.038,4.038,0,0,1-2.29.2,15.17,15.17,0,0,0,1.592,3.24c1.257.838,4.329,2.095,4.162,2.151a9.243,9.243,0,0,1-1.955.335,11.612,11.612,0,0,0,2.151,1.452c1.592.866,3.547,1.285,4.748,2.625.028.028.056.056.084.056a.144.144,0,0,0,.251,0c1.983-3.6,1.061-7.541.2-11.089a3.4,3.4,0,0,0-.14-.5,11.909,11.909,0,0,1-1.983,2.9c-.112.112.782-3.435,1.257-5.111a7.463,7.463,0,0,0-1.424-2.207,20.2,20.2,0,0,0-4.776-3.38,1.664,1.664,0,0,0-.224-.112,8,8,0,0,1-.475,2.514,22.013,22.013,0,0,1-.782-3.184c-.419-.2-.81-.419-1.229-.587-.559-.251-1.313-.754-1.955-.391s-1.257,3.408-1.173,4.19c.028.335.084.67.112,1.005a2.178,2.178,0,0,1,.056.447,37.175,37.175,0,0,0,.922,3.966c.084.056.14.084.223.14A21.162,21.162,0,0,1,1471.246,508.26Z",
    transform: "translate(-1467.273 -484.398)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6533",
    "data-name": "Grupo 6533",
    transform: "translate(0.119 15.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7284",
    "data-name": "Caminho 7284",
    d: "M1487.162,539.324a61.7,61.7,0,0,0-2.989-12.932.085.085,0,0,0,0-.112c-.168-.447-.363-.866-.559-1.285-.279-.67-.558-1.313-.866-1.983,0-.028-.028-.028-.056-.056-.81-1.788-1.676-3.547-2.6-5.307l.056-.056a8.44,8.44,0,0,0,.67-3.072c0-.2-.335-.2-.363,0a8.7,8.7,0,0,1-.559,2.765c-.279-.531-.558-1.061-.866-1.592a.218.218,0,0,0,.112-.112,13.179,13.179,0,0,0,.67-4.385c0-.2-.363-.2-.363,0a12.644,12.644,0,0,1-.614,4.162c-1.341-2.4-2.765-4.748-4.3-7.039-.112-.168-.419,0-.307.168,1.145,1.732,2.262,3.491,3.3,5.279a8.076,8.076,0,0,1-4.078-.447c-.2-.056-.307.251-.112.307a8.146,8.146,0,0,0,4.329.447h0a98.811,98.811,0,0,1,4.664,9.05,5.24,5.24,0,0,1-1.871-.726c-.167-.112-.363.168-.2.279a5.839,5.839,0,0,0,2.039.782.21.21,0,0,0,.14-.028c.224.475.419.978.642,1.452a57.544,57.544,0,0,1,3.6,14.552A3.35,3.35,0,0,1,1487.162,539.324Z",
    transform: "translate(-1471.689 -508.251)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7285",
    "data-name": "Caminho 7285",
    d: "M1470.745,517.1a8.794,8.794,0,0,1-3.045-1.2,2.162,2.162,0,0,1,.056.447,8.96,8.96,0,0,0,2.849,1.061C1470.856,517.464,1470.968,517.157,1470.745,517.1Z",
    transform: "translate(-1467.7 -513.764)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7286",
    "data-name": "Caminho 7286",
    d: "M1549.811,524.1c-.028,1.4-3.268,2.095-4.3,2.458-2.29.838-4.525,1.7-6.2,3.547a73.973,73.973,0,0,0-5.418,7.067.418.418,0,0,1-.419.168,6.576,6.576,0,0,1-.475-1.033c-.587-1.452-1.508-4.134-1.285-5.642a9.818,9.818,0,0,1,1.033-3.044,2.67,2.67,0,0,0,.642,1.285,25.941,25.941,0,0,0,.363-2.821,4.3,4.3,0,0,1,.475-.531,11.373,11.373,0,0,1,1.2-1.117c.084-.084.2-.14.279-.223.363-.251.726-.5,1.089-.726.112-.056.2-.112.307-.168a9.755,9.755,0,0,1,1.089-.531,7.291,7.291,0,0,0,.615,2.011,13.93,13.93,0,0,0,.251-2.346,8.1,8.1,0,0,1,1.089-.335,6.34,6.34,0,0,0,.447,1.285,6.159,6.159,0,0,0,.7-1.564,14.857,14.857,0,0,1,3.491-.279,1.144,1.144,0,0,1,.307.028c.307.028.615.056.922.112,1.117.168,3.771.894,3.8,2.4Z",
    transform: "translate(-1513.689 -502.058)",
    fill: "#009db0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6534",
    "data-name": "Grupo 6534",
    transform: "translate(19.021 21.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7287",
    "data-name": "Caminho 7287",
    d: "M1539.961,534.315c-2.765,2.737-3.631,7.737-3.8,9.161a5.674,5.674,0,0,0-.559,1.843,40.312,40.312,0,0,0-.168,6.871c.028.754.056,1.48.084,2.234.14-.028.251-.056.391-.084-.028-.475-.056-.95-.056-1.4-.056-2.039-.056-4.05.028-6.089a8.919,8.919,0,0,1,.559-3.072.218.218,0,0,0,.112-.112,78.879,78.879,0,0,1,5.419-7.067c1.7-1.843,3.91-2.681,6.2-3.547,1.033-.391,4.273-1.061,4.3-2.458C1548.144,531.131,1543.145,531.187,1539.961,534.315Z",
    transform: "translate(-1535.372 -529.874)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7288",
    "data-name": "Caminho 7288",
    d: "M1550.238,531.128a9.067,9.067,0,0,1-.056-3.128c-.112.056-.2.112-.307.168a9.122,9.122,0,0,0,.084,3.017A.143.143,0,0,0,1550.238,531.128Z",
    transform: "translate(-1545.761 -528)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7289",
    "data-name": "Caminho 7289",
    d: "M1545.87,533.993a10.536,10.536,0,0,1-.391-2.793,1.961,1.961,0,0,0-.279.224,12.176,12.176,0,0,0,.391,2.653C1545.647,534.217,1545.926,534.161,1545.87,533.993Z",
    transform: "translate(-1542.455 -530.306)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6536",
    "data-name": "Grupo 6536",
    transform: "translate(6.767 39.783)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7290",
    "data-name": "Caminho 7290",
    d: "M1511.878,598.166a10.517,10.517,0,0,1-.224,2.123,10.216,10.216,0,0,1-3.966,6.089h-11.9a10.217,10.217,0,0,1-3.966-6.089,10.735,10.735,0,0,1-.223-2.123,9.542,9.542,0,0,1,.251-2.207,11.764,11.764,0,0,1,.558-1.76H1511.1a9.215,9.215,0,0,1,.559,1.76A11.366,11.366,0,0,1,1511.878,598.166Z",
    transform: "translate(-1491.572 -594.2)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7291",
    "data-name": "Caminho 7291",
    d: "M1522.688,598.166a10.517,10.517,0,0,1-.224,2.123,10.216,10.216,0,0,1-3.966,6.089h-11.9c15.53.782,15.278-12.178,15.278-12.178a9.233,9.233,0,0,1,.559,1.76A9.549,9.549,0,0,1,1522.688,598.166Z",
    transform: "translate(-1502.382 -594.2)",
    fill: "#cf3b59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7292",
    "data-name": "Caminho 7292",
    d: "M1496.025,594.2h-3.715a11.75,11.75,0,0,0-.559,1.76,9.542,9.542,0,0,0-.251,2.207,10.508,10.508,0,0,0,.224,2.123,10.216,10.216,0,0,0,3.966,6.089h1.648C1495.354,604.925,1494.433,598.334,1496.025,594.2Z",
    transform: "translate(-1491.5 -594.2)",
    fill: "#ff5675"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6566",
    "data-name": "Grupo 6566",
    transform: "translate(1465.983 101.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6542",
    "data-name": "Grupo 6542",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6541",
    "data-name": "Grupo 6541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6540",
    "data-name": "Grupo 6540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6539",
    "data-name": "Grupo 6539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7293",
    "data-name": "Caminho 7293",
    d: "M1525.75,346.79l51.923-8.156-15.25-97.534-51.923,8.128Z",
    transform: "translate(-1505.838 -237.553)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7294",
    "data-name": "Caminho 7294",
    d: "M1499.782,244.773l28.88-4.273.642,4.106-13.239,2.067-11.424,1.815a7.048,7.048,0,0,0-5.865,8.072l12.429,79.463a7.035,7.035,0,0,0,8.044,5.865l24.663-3.743,1.341,8.631-28.8,4.748a7.026,7.026,0,0,1-8.044-5.865l-14.524-92.814A7.088,7.088,0,0,1,1499.782,244.773Z",
    transform: "translate(-1493.807 -237.121)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6538",
    "data-name": "Grupo 6538",
    transform: "translate(2.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7295",
    "data-name": "Caminho 7295",
    d: "M1504.092,243.624l14.356,92.842a7.058,7.058,0,0,0,7.569,5.949,2.75,2.75,0,0,0,.475-.056l45.862-7.094a4.6,4.6,0,0,0,3.827-5.223l-15.11-97.757a4.579,4.579,0,0,0-5.223-3.827l-45.862,7.094c-.168.028-.335.056-.475.084A7.128,7.128,0,0,0,1504.092,243.624Zm4.5,1.285a4.573,4.573,0,0,1,3.827-5.223l39.941-6.173a4.573,4.573,0,0,1,5.223,3.826l13.044,84.379a4.573,4.573,0,0,1-3.827,5.223l-39.941,6.173a4.573,4.573,0,0,1-5.223-3.827Z",
    transform: "translate(-1504.011 -228.402)",
    fill: "url(#linear-gradient-12)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7296",
    "data-name": "Caminho 7296",
    d: "M1639.172,603.656l8.8-1.4a2.154,2.154,0,0,0,1.788-2.43h0a2.155,2.155,0,0,0-2.43-1.788l-8.8,1.4a2.155,2.155,0,0,0-1.788,2.43h0A2.1,2.1,0,0,0,1639.172,603.656Z",
    transform: "translate(-1596.803 -494.783)",
    fill: "#312da4"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7297",
    "data-name": "Caminho 7297",
    d: "M1629.889,464.706l-32.483,5.028a1.1,1.1,0,0,1-1.257-.922l-.978-6.256a1.1,1.1,0,0,1,.922-1.257l32.483-5.028a1.1,1.1,0,0,1,1.257.922l.978,6.256A1.088,1.088,0,0,1,1629.889,464.706Z",
    transform: "translate(-1566.851 -392.618)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6543",
    "data-name": "Grupo 6543",
    transform: "translate(10.947 12.847)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_637",
    "data-name": "Elipse 637",
    cx: 1.424,
    cy: 1.424,
    r: 1.424,
    transform: "translate(10.865)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_638",
    "data-name": "Elipse 638",
    cx: 1.424,
    cy: 1.424,
    r: 1.424,
    transform: "translate(5.446 0.838)",
    fill: "#ff5472"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_639",
    "data-name": "Elipse 639",
    cx: 1.424,
    cy: 1.424,
    r: 1.424,
    transform: "translate(0 1.676)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6544",
    "data-name": "Grupo 6544",
    transform: "translate(10.653 13.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7298",
    "data-name": "Caminho 7298",
    d: "M1580.724,289.4l6.256,37.148s-38.935,6.592-38.935,6.312c-.028-.307-6.145-37.818-6.145-37.818Z",
    transform: "translate(-1539.121 -285.559)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7299",
    "data-name": "Caminho 7299",
    d: "M1533.22,282.227a1.525,1.525,0,0,0-1.257,1.7l1.508,9.608.307,2.039,5.167,33.126a1.525,1.525,0,0,0,1.7,1.257l41.98-6.536a1.525,1.525,0,0,0,1.257-1.7l-6.983-44.8a1.525,1.525,0,0,0-1.7-1.257Zm4.916,12.708-.67-4.3-.475-3.044a1.483,1.483,0,0,1,1.257-1.7l33.293-5.2a1.469,1.469,0,0,1,1.7,1.257l4.888,31.31a1.469,1.469,0,0,1-1.257,1.7l-33.293,5.2a1.469,1.469,0,0,1-1.7-1.257Z",
    transform: "translate(-1531.949 -275.649)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6548",
    "data-name": "Grupo 6548",
    transform: "translate(19.438 69.547)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_640",
    "data-name": "Elipse 640",
    cx: 4.301,
    cy: 4.301,
    r: 4.301,
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_641",
    "data-name": "Elipse 641",
    cx: 3.743,
    cy: 3.743,
    r: 3.743,
    transform: "translate(0.559 0.559)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6547",
    "data-name": "Grupo 6547",
    transform: "translate(0.559 0.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6546",
    "data-name": "Grupo 6546",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7300",
    "data-name": "Caminho 7300",
    d: "M1578.871,501a1.216,1.216,0,0,1-.028.14,1.591,1.591,0,0,0-.028.363v.335a3.875,3.875,0,0,0,.084.531,2.111,2.111,0,0,1-1.9.112,2.256,2.256,0,0,0,.028-.447c0-.335-.028-.642-.028-.726v-.028h0Z",
    transform: "translate(-1573.76 -494.967)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7301",
    "data-name": "Caminho 7301",
    d: "M1578.943,501a1.211,1.211,0,0,1-.028.14,1.852,1.852,0,0,0-.028.363v.335a2.434,2.434,0,0,1-1.229.391.92.92,0,0,1-.531-.168c0-.335-.028-.642-.028-.726v-.028h0Z",
    transform: "translate(-1573.832 -494.967)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7302",
    "data-name": "Caminho 7302",
    d: "M1572.3,498.435s.5.726.866.614c.307-.084-.419-.95-.419-.95Z",
    transform: "translate(-1570.373 -492.877)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7303",
    "data-name": "Caminho 7303",
    d: "M1572.714,491.124s.559.95,1.005,1.117a2.256,2.256,0,0,0,1.983-.559c.391-.67-.307-3.156-.447-3.38s-2.29-.782-2.821.279A3.211,3.211,0,0,0,1572.714,491.124Z",
    transform: "translate(-1570.34 -485.566)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7304",
    "data-name": "Caminho 7304",
    d: "M1573.549,484.706c-.14.335-1.648-.251-2.681.056a2.2,2.2,0,0,0-1.229,1.4c-.2.112-.279.67-.168,1.033.5,1.369,1.257,1.508,1.369,1.452.615-.279.475-1.452,0-2.29a5.175,5.175,0,0,1,1.62-.251c.279.028.81.2,1.061-.028C1573.884,485.8,1573.884,484.846,1573.549,484.706Z",
    transform: "translate(-1568.298 -483.198)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6545",
    "data-name": "Grupo 6545",
    transform: "translate(1.643 4.853)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7305",
    "data-name": "Caminho 7305",
    d: "M1571.986,496.839c-.168-.112-.642-.084-.7.168a.571.571,0,0,0,.894.559C1572.377,497.425,1572.126,496.951,1571.986,496.839Z",
    transform: "translate(-1571.283 -496.776)",
    fill: "#f5f5ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6551",
    "data-name": "Grupo 6551",
    transform: "translate(21.197 80.942)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_643",
    "data-name": "Elipse 643",
    cx: 4.301,
    cy: 4.301,
    r: 4.301,
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_644",
    "data-name": "Elipse 644",
    cx: 3.743,
    cy: 3.743,
    r: 3.743,
    transform: "translate(0.559 0.559)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6550",
    "data-name": "Grupo 6550",
    transform: "translate(1.784 1.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7306",
    "data-name": "Caminho 7306",
    d: "M1585.211,540.2c0,.056-.028.112-.028.168a1.835,1.835,0,0,0-.028.391v.363a2.344,2.344,0,0,0,.112.586,2.317,2.317,0,0,1-2.067.14,2.714,2.714,0,0,0,.028-.5c0-.363-.028-.7-.028-.81v-.028h0Z",
    transform: "translate(-1581.213 -535.79)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7307",
    "data-name": "Caminho 7307",
    d: "M1585.211,540.2c0,.056-.028.112-.028.168a2.271,2.271,0,0,0-.028.391v.363a2.416,2.416,0,0,1-1.341.419,1.467,1.467,0,0,1-.587-.168c0-.363-.028-.7-.028-.81v-.028h0Z",
    transform: "translate(-1581.213 -535.79)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7308",
    "data-name": "Caminho 7308",
    d: "M1580.974,532.772s.251.782.67.922,1.648.084,2.011-.475c.391-.615-.224-2.849-.363-3.044s-2.123-.726-2.6.251A3,3,0,0,0,1580.974,532.772Z",
    transform: "translate(-1579.295 -528.334)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7309",
    "data-name": "Caminho 7309",
    d: "M1580.353,525.3c.056-.531-.224-1.061-.894-.838-.112.028-.2.14-.307.168-.084.028-.2-.056-.335-.028a.466.466,0,0,0-.363.2.829.829,0,0,0-1.257.614.57.57,0,0,0-.559.251.425.425,0,0,0-.028.475.446.446,0,0,0-.224.391.585.585,0,0,0,.112.307.649.649,0,0,0-.307.615.831.831,0,0,0,.279.559.545.545,0,0,0,.14.5.6.6,0,0,0,.447.2,1.078,1.078,0,0,0,1.229.95c-.419-.67-.419-1.955-.726-2.6a13.867,13.867,0,0,0,1.9-.67,1.573,1.573,0,0,0,1.229-.2A.531.531,0,0,0,1580.353,525.3Z",
    transform: "translate(-1576.16 -524.412)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7310",
    "data-name": "Caminho 7310",
    d: "M1577.013,531.41c-.307-.056-.251-.475-.14-.782a2.115,2.115,0,0,1-.419-.028.415.415,0,0,0-.168.363.585.585,0,0,0,.112.307.649.649,0,0,0-.307.614.831.831,0,0,0,.279.559.546.546,0,0,0,.14.5.6.6,0,0,0,.447.2,1.077,1.077,0,0,0,1.229.95,10.628,10.628,0,0,1-.559-2.151C1577.32,531.913,1576.957,531.717,1577.013,531.41Z",
    transform: "translate(-1576.088 -528.872)",
    fill: "#d2d2ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6549",
    "data-name": "Grupo 6549",
    transform: "translate(0.977 3.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7311",
    "data-name": "Caminho 7311",
    d: "M1580.344,537.22c-.14-.112-.7-.2-.754.056-.056.363.475.95.922.614C1580.679,537.751,1580.483,537.3,1580.344,537.22Z",
    transform: "translate(-1579.586 -537.112)",
    fill: "#f5f5ff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6558",
    "data-name": "Grupo 6558",
    transform: "translate(22.985 92.534)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_645",
    "data-name": "Elipse 645",
    cx: 4.301,
    cy: 4.301,
    r: 4.301,
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_646",
    "data-name": "Elipse 646",
    cx: 3.715,
    cy: 3.715,
    r: 3.715,
    transform: "translate(0.587 0.587)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6557",
    "data-name": "Grupo 6557",
    transform: "translate(0.587 0.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6556",
    "data-name": "Grupo 6556",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7312",
    "data-name": "Caminho 7312",
    d: "M1594.957,580.624c-.223.112.2,1.285,1.871,3.128.419.475.81-.335.586-.642s-1.173-1.592-1.173-1.592S1595.376,580.4,1594.957,580.624Z",
    transform: "translate(-1590.237 -575.345)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7313",
    "data-name": "Caminho 7313",
    d: "M1594.957,580.611c-.223.112.2,1.285,1.871,3.128-.5-1.2-.587-1.592-.782-2.095C1595.879,581.309,1595.376,580.388,1594.957,580.611Z",
    transform: "translate(-1590.237 -575.332)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7314",
    "data-name": "Caminho 7314",
    d: "M1596.354,581.434a1.448,1.448,0,0,1-.251.335,1.49,1.49,0,0,1-.531.363,4.891,4.891,0,0,1-.559-1.034c0-.028-.028-.084-.028-.112s-.028-.056-.028-.112c-.028-.168-.028-.251.056-.279.028,0,.028-.028.056-.028.056,0,.084-.028.14,0h.028C1595.683,580.652,1596.354,581.434,1596.354,581.434Z",
    transform: "translate(-1590.265 -575.317)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7315",
    "data-name": "Caminho 7315",
    d: "M1595.922,582.117a1.216,1.216,0,0,1-.5.391,5.172,5.172,0,0,1-.642-.978c-.028-.028-.028-.056-.028-.112,0-.028-.028-.056-.028-.084-.056-.168-.028-.251.028-.279.028,0,.028-.028.056-.028a.251.251,0,0,1,.14-.028h.028c.391.056.81.726.922,1.005C1595.895,582.034,1595.922,582.089,1595.922,582.117Z",
    transform: "translate(-1590.085 -575.637)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7316",
    "data-name": "Caminho 7316",
    d: "M1593.312,585.5a5.784,5.784,0,0,1-3.212.168,18.133,18.133,0,0,0,.419-2.234,9.041,9.041,0,0,0-.14-1.4,3.39,3.39,0,0,0-.223-.894c-.084-.223.112-.419.279-.531a.212.212,0,0,1,.112-.056.305.305,0,0,0,.112-.056l.67-.112a.458.458,0,0,1,.391.168,4.407,4.407,0,0,1,.894,2.067.357.357,0,0,1-.335.391C1592.418,583.514,1593.312,585.5,1593.312,585.5Z",
    transform: "translate(-1586.776 -575.191)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7317",
    "data-name": "Caminho 7317",
    d: "M1595.766,589.728a5.115,5.115,0,0,1-.866-.028,1.474,1.474,0,0,0,.922.279Z",
    transform: "translate(-1590.236 -581.907)",
    fill: "#e0ca7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7318",
    "data-name": "Caminho 7318",
    d: "M1590.24,582.8a10.966,10.966,0,0,1,.251,2.4c-.084.587-.391,1.983-.391,1.983s.922.14,1.424.168a1.279,1.279,0,0,1-.7-1.173c.028-.838-.224-2.793-.14-3.519C1590.407,582.3,1590.24,582.8,1590.24,582.8Z",
    transform: "translate(-1586.776 -576.739)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7319",
    "data-name": "Caminho 7319",
    d: "M1585.007,584.463c.224.056.391.251.559-.028a10.9,10.9,0,0,0,1.005-1.955l.168-.419h0a3.155,3.155,0,0,0,.168-.81q0-.209-.084-.251h-.084a1.215,1.215,0,0,0-.14.028c-.419.2-.866,1.089-.866,1.089s-.7,1.508-.866,1.843C1584.783,584.128,1584.783,584.408,1585.007,584.463Z",
    transform: "translate(-1582.968 -575.637)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7320",
    "data-name": "Caminho 7320",
    d: "M1585.5,587.2c.168.168.391.251.559-.028a10.9,10.9,0,0,0,1.005-1.955l.168-.419a23.923,23.923,0,0,1-1.424,2.43A.639.639,0,0,1,1585.5,587.2Z",
    transform: "translate(-1583.461 -578.376)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7321",
    "data-name": "Caminho 7321",
    d: "M1589.013,581.251a3.577,3.577,0,0,1-.251,1.313,1.124,1.124,0,0,1-1.061-.5,3.8,3.8,0,0,1,.978-1.033.251.251,0,0,1,.14-.028h.084C1588.985,581,1589.013,581.112,1589.013,581.251Z",
    transform: "translate(-1585.047 -575.637)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6552",
    "data-name": "Grupo 6552",
    transform: "translate(3.659 5.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7322",
    "data-name": "Caminho 7322",
    d: "M1592.613,580.468a.551.551,0,0,0-.391-.168l-.67.112-.112.056c-.056,0-.084.028-.14.028l.028.028c.084.056.2.14.279.2.056.056.14.084.2.14a2.523,2.523,0,0,0,.447.307c.224.084.363-.14.363-.335A.8.8,0,0,0,1592.613,580.468Z",
    transform: "translate(-1591.3 -580.3)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7323",
    "data-name": "Caminho 7323",
    d: "M1592.666,577.1a8.853,8.853,0,0,0,.056.978c-.112.475-.866.084-.866.084v-.335c-.028-.251-.056-.475-.056-.531h0Z",
    transform: "translate(-1588.001 -572.827)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7324",
    "data-name": "Caminho 7324",
    d: "M1592.45,577.1v.363c0,.084.028.223.028.307-.168.168-.726-.14-.894-.363-.028-.251-.084-.5-.084-.5Z",
    transform: "translate(-1587.785 -572.682)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7325",
    "data-name": "Caminho 7325",
    d: "M1592.615,580.517c-.112.307-.67.14-.866.056-.084-.056-.14.056-.056.084.279.14.95.279,1.005-.14C1592.7,580.489,1592.643,580.461,1592.615,580.517Z",
    transform: "translate(-1587.895 -575.266)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6553",
    "data-name": "Grupo 6553",
    transform: "translate(0.835 1.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7326",
    "data-name": "Caminho 7326",
    d: "M1583.624,567.413c.028-.028-.307-.14-.335-.168a1.366,1.366,0,0,0-1.732.95c-.279,1.229.782,2.709-.335,3.743-.056.056-.028.112.028.14a1.145,1.145,0,0,0,.754-.112,2.065,2.065,0,0,0,.95-1.955c-.028-.642-.307-1.4.056-1.927a.9.9,0,0,1,.335-.307C1583.568,567.636,1583.847,567.525,1583.624,567.413Z",
    transform: "translate(-1581.191 -567.185)",
    fill: "#e8e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6554",
    "data-name": "Grupo 6554",
    transform: "translate(1.627 2.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7327",
    "data-name": "Caminho 7327",
    d: "M1584.493,571.8c0,.391.084.81.056,1.2a2.509,2.509,0,0,1-.5,1.229c-.028.028-.028.056,0,.056a2.066,2.066,0,0,0,.95-1.955c-.028-.642-.307-1.4.056-1.927A1.67,1.67,0,0,0,1584.493,571.8Z",
    transform: "translate(-1584.025 -570.4)",
    fill: "#d2d2ed"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7328",
    "data-name": "Caminho 7328",
    d: "M1593.529,568.3a6.2,6.2,0,0,1,.475,1.369,1.128,1.128,0,0,1-.754,1.369c-.224.056-.95-1.089-.95-1.089Z",
    transform: "translate(-1588.362 -566.484)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7329",
    "data-name": "Caminho 7329",
    d: "M1590,569.976a4.736,4.736,0,0,0,.5,1.676,1.252,1.252,0,0,0,1.173.335c.475-.168.615-1.089.475-1.927C1591.955,569.026,1590.922,568.719,1590,569.976Z",
    transform: "translate(-1586.704 -567.099)",
    fill: "#f5f5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7330",
    "data-name": "Caminho 7330",
    d: "M1587.017,567.447h0a1.491,1.491,0,0,1,.419-.615,2.521,2.521,0,0,1,1.117-.586c1.7-.335,1.983.838,1.145,1.089-.67.2-1.815.447-1.815.447a2.431,2.431,0,0,1,.14,1.033c-.028,0-.028-.028-.056-.028a3.567,3.567,0,0,0,.363.81c-.251.251-.95.14-1.2-.559A2.965,2.965,0,0,1,1587.017,567.447Z",
    transform: "translate(-1584.503 -564.961)",
    fill: "#e8e8f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6555",
    "data-name": "Grupo 6555",
    transform: "translate(3.152 3.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7331",
    "data-name": "Caminho 7331",
    d: "M1590.019,574.609c-.112-.084-.475-.279-.531-.028-.056.279.419.894.614.5A.462.462,0,0,0,1590.019,574.609Z",
    transform: "translate(-1589.484 -574.457)",
    fill: "#f5f5ff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6559",
    "data-name": "Grupo 6559",
    transform: "translate(29.769 66.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7332",
    "data-name": "Caminho 7332",
    d: "M1613.071,476.086l-12.234,1.9a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l12.234-1.9a.443.443,0,0,1,.447.391A.392.392,0,0,1,1613.071,476.086Z",
    transform: "translate(-1600.387 -472.284)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7333",
    "data-name": "Caminho 7333",
    d: "M1621.447,483.486l-18.909,2.933a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l18.909-2.933a.443.443,0,0,1,.447.391A.449.449,0,0,1,1621.447,483.486Z",
    transform: "translate(-1601.613 -477.617)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7334",
    "data-name": "Caminho 7334",
    d: "M1668.2,465.686l-17.066,2.625a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l17.066-2.625a.443.443,0,0,1,.447.391A.432.432,0,0,1,1668.2,465.686Z",
    transform: "translate(-1636.638 -464.789)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7335",
    "data-name": "Caminho 7335",
    d: "M1694.263,476.686l-7.625,1.173a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l7.625-1.173a.443.443,0,0,1,.447.391A.432.432,0,0,1,1694.263,476.686Z",
    transform: "translate(-1662.223 -472.717)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7336",
    "data-name": "Caminho 7336",
    d: "M1636.189,505.506l-32.484,5.028a1.1,1.1,0,0,1-1.257-.922l-.978-6.257a1.1,1.1,0,0,1,.922-1.257l32.483-5.027a1.1,1.1,0,0,1,1.257.922l.978,6.257A1.1,1.1,0,0,1,1636.189,505.506Z",
    transform: "translate(-1571.391 -422.022)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6560",
    "data-name": "Grupo 6560",
    transform: "translate(31.528 77.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7337",
    "data-name": "Caminho 7337",
    d: "M1619.371,516.886l-12.234,1.9a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l12.234-1.9a.443.443,0,0,1,.447.391A.392.392,0,0,1,1619.371,516.886Z",
    transform: "translate(-1606.687 -513.084)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7338",
    "data-name": "Caminho 7338",
    d: "M1627.747,524.186l-18.909,2.933a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l18.909-2.933a.443.443,0,0,1,.447.391A.432.432,0,0,1,1627.747,524.186Z",
    transform: "translate(-1607.913 -518.345)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7339",
    "data-name": "Caminho 7339",
    d: "M1674.5,506.486l-17.066,2.625a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l17.066-2.625a.443.443,0,0,1,.447.391A.425.425,0,0,1,1674.5,506.486Z",
    transform: "translate(-1642.938 -505.589)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7340",
    "data-name": "Caminho 7340",
    d: "M1700.563,517.486l-7.625,1.173a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l7.625-1.173a.443.443,0,0,1,.447.391A.432.432,0,0,1,1700.563,517.486Z",
    transform: "translate(-1668.523 -513.517)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7341",
    "data-name": "Caminho 7341",
    d: "M1642.589,547.006l-32.483,5.028a1.1,1.1,0,0,1-1.257-.922l-.977-6.257a1.1,1.1,0,0,1,.922-1.257l32.483-5.028a1.1,1.1,0,0,1,1.257.922l.978,6.256A1.088,1.088,0,0,1,1642.589,547.006Z",
    transform: "translate(-1576.004 -451.931)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6561",
    "data-name": "Grupo 6561",
    transform: "translate(33.316 89.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7342",
    "data-name": "Caminho 7342",
    d: "M1625.771,558.386l-12.234,1.9a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l12.234-1.9a.443.443,0,0,1,.447.391A.392.392,0,0,1,1625.771,558.386Z",
    transform: "translate(-1613.087 -554.584)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7343",
    "data-name": "Caminho 7343",
    d: "M1634.128,565.786l-18.909,2.933a.443.443,0,0,1-.447-.391.41.41,0,0,1,.307-.5l18.909-2.933a.443.443,0,0,1,.447.391A.468.468,0,0,1,1634.128,565.786Z",
    transform: "translate(-1614.294 -559.917)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7344",
    "data-name": "Caminho 7344",
    d: "M1680.9,547.986l-17.066,2.625a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l17.066-2.626a.443.443,0,0,1,.447.391A.432.432,0,0,1,1680.9,547.986Z",
    transform: "translate(-1649.338 -547.089)",
    fill: "#dcddf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7345",
    "data-name": "Caminho 7345",
    d: "M1706.963,558.986l-7.625,1.173a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l7.625-1.173a.443.443,0,0,1,.447.391A.432.432,0,0,1,1706.963,558.986Z",
    transform: "translate(-1674.923 -555.017)",
    fill: "#dcddf9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6562",
    "data-name": "Grupo 6562",
    transform: "translate(18.421 22.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7346",
    "data-name": "Caminho 7346",
    d: "M1572.453,320.786l-12.234,1.9a.443.443,0,0,1-.447-.391.41.41,0,0,1,.307-.5l12.234-1.9a.443.443,0,0,1,.447.391A.41.41,0,0,1,1572.453,320.786Z",
    transform: "translate(-1559.761 -316.984)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7347",
    "data-name": "Caminho 7347",
    d: "M1580.728,328.186l-18.909,2.933a.443.443,0,0,1-.447-.391.41.41,0,0,1,.307-.5l18.909-2.933a.443.443,0,0,1,.447.391A.392.392,0,0,1,1580.728,328.186Z",
    transform: "translate(-1560.914 -322.318)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7348",
    "data-name": "Caminho 7348",
    d: "M1634.71,310.386l-14.272,2.207a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l14.273-2.207a.443.443,0,0,1,.447.391A.432.432,0,0,1,1634.71,310.386Z",
    transform: "translate(-1603.166 -309.489)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7349",
    "data-name": "Caminho 7349",
    d: "M1653.544,321.386l-7.625,1.173a.443.443,0,0,1-.447-.391.41.41,0,0,1,.307-.5l7.625-1.173a.443.443,0,0,1,.447.391A.41.41,0,0,1,1653.544,321.386Z",
    transform: "translate(-1621.525 -317.417)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6563",
    "data-name": "Grupo 6563",
    transform: "translate(19.351 28.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7350",
    "data-name": "Caminho 7350",
    d: "M1631.138,334.385l12.234-1.9a.432.432,0,0,0,.307-.5.41.41,0,0,0-.447-.391l-12.234,1.9a.432.432,0,0,0-.307.5A.41.41,0,0,0,1631.138,334.385Z",
    transform: "translate(-1611.806 -331.589)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7351",
    "data-name": "Caminho 7351",
    d: "M1608.938,346.419l18.909-2.933a.432.432,0,0,0,.307-.5.41.41,0,0,0-.447-.391l-18.909,2.933a.432.432,0,0,0-.307.5A.443.443,0,0,0,1608.938,346.419Z",
    transform: "translate(-1595.807 -339.517)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7352",
    "data-name": "Caminho 7352",
    d: "M1563.538,342.911l17.066-2.626a.432.432,0,0,0,.307-.5.41.41,0,0,0-.447-.391l-17.066,2.625a.432.432,0,0,0-.307.5C1563.119,342.772,1563.342,342.967,1563.538,342.911Z",
    transform: "translate(-1563.088 -337.211)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7353",
    "data-name": "Caminho 7353",
    d: "M1565.238,357.659l7.625-1.173a.432.432,0,0,0,.307-.5.41.41,0,0,0-.447-.391l-7.625,1.173a.432.432,0,0,0-.307.5C1564.847,357.547,1565.042,357.715,1565.238,357.659Z",
    transform: "translate(-1564.313 -348.886)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6564",
    "data-name": "Grupo 6564",
    transform: "translate(20.328 35.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7354",
    "data-name": "Caminho 7354",
    d: "M1579.271,365.286l-12.234,1.9a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l12.234-1.9a.443.443,0,0,1,.447.391C1579.607,365.035,1579.495,365.258,1579.271,365.286Z",
    transform: "translate(-1566.587 -361.456)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7355",
    "data-name": "Caminho 7355",
    d: "M1587.647,372.586l-18.909,2.933a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l18.909-2.933a.443.443,0,0,1,.447.391A.432.432,0,0,1,1587.647,372.586Z",
    transform: "translate(-1567.813 -366.718)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7356",
    "data-name": "Caminho 7356",
    d: "M1641.51,354.786l-14.273,2.207a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l14.272-2.207a.443.443,0,0,1,.447.391A.392.392,0,0,1,1641.51,354.786Z",
    transform: "translate(-1609.973 -353.889)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7357",
    "data-name": "Caminho 7357",
    d: "M1660.363,365.886l-7.625,1.173a.443.443,0,0,1-.447-.391.432.432,0,0,1,.307-.5l7.625-1.173a.443.443,0,0,1,.447.391A.416.416,0,0,1,1660.363,365.886Z",
    transform: "translate(-1628.351 -361.889)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6565",
    "data-name": "Grupo 6565",
    transform: "translate(21.278 41.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7358",
    "data-name": "Caminho 7358",
    d: "M1637.938,378.785l12.234-1.9a.432.432,0,0,0,.307-.5.41.41,0,0,0-.447-.391l-12.234,1.9a.432.432,0,0,0-.307.5C1637.547,378.646,1637.742,378.841,1637.938,378.785Z",
    transform: "translate(-1618.634 -375.989)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7359",
    "data-name": "Caminho 7359",
    d: "M1615.838,390.819l18.909-2.933a.432.432,0,0,0,.307-.5.41.41,0,0,0-.447-.391l-18.909,2.933a.432.432,0,0,0-.307.5C1615.419,390.679,1615.614,390.875,1615.838,390.819Z",
    transform: "translate(-1602.707 -383.917)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7360",
    "data-name": "Caminho 7360",
    d: "M1570.438,387.411l17.066-2.625a.432.432,0,0,0,.307-.5.41.41,0,0,0-.447-.391l-17.066,2.626a.432.432,0,0,0-.307.5A.443.443,0,0,0,1570.438,387.411Z",
    transform: "translate(-1569.987 -381.683)",
    fill: "#f7f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7361",
    "data-name": "Caminho 7361",
    d: "M1572.138,402.159l7.625-1.173a.432.432,0,0,0,.307-.5.41.41,0,0,0-.447-.391L1572,401.265a.432.432,0,0,0-.307.5A.425.425,0,0,0,1572.138,402.159Z",
    transform: "translate(-1571.213 -393.358)",
    fill: "#f7f7f7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6586",
    "data-name": "Grupo 6586",
    transform: "translate(1506.062 100.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6585",
    "data-name": "Grupo 6585",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6584",
    "data-name": "Grupo 6584",
    transform: "translate(2.583 2.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7362",
    "data-name": "Caminho 7362",
    d: "M1689.725,455.257c-3.24-13.714-6.983-29.16-7.988-31.757,0,0-3.854,1.76-6.955,3.184-4.134-.642-8.072-1.257-8.351-1.341,0,0-1.9,7.96-2.681,13.044-1.117,7.513-5.949,40.751-5.949,40.751l2.011.531,14.887-38.8h0c1.285,2.737,5.5,8.6,8.24,14.608h.056c2.318,11.061,4.8,22.875,4.8,22.875l2.067-.2C1689.892,478.188,1689.865,467.379,1689.725,455.257Z",
    transform: "translate(-1654.657 -370.829)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7363",
    "data-name": "Caminho 7363",
    d: "M1732.042,518.715l-.67-.279s-.615-2.849-1.508-7.066c-.922-4.245-2.095-9.887-3.3-15.474-2.681-5.893-6.675-11.088-8.267-14.636a23.346,23.346,0,0,0,4.385-1.76c.223.81.363,1.117.615,1.927.754,2.6,2.57,8.212,4.776,14.5A173.8,173.8,0,0,0,1732.042,518.715Z",
    transform: "translate(-1698.259 -411.188)",
    fill: "#d6695d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7364",
    "data-name": "Caminho 7364",
    d: "M1718.3,476.431s5.167-2.262,5.949-3.631a6.739,6.739,0,0,1-4.106,4.972Z",
    transform: "translate(-1698.259 -406.359)",
    fill: "#d6695d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6567",
    "data-name": "Grupo 6567",
    transform: "translate(32.861 105.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7365",
    "data-name": "Caminho 7365",
    d: "M1764.2,614.46l.112,1.843,7.29-1.648a9.524,9.524,0,0,0-5.083-.7c.084.223-1.536.978-2.234.531Z",
    transform: "translate(-1764.2 -613.824)",
    fill: "#1b0a74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2003",
    "data-name": "Ret\\xE2ngulo 2003",
    width: 7.485,
    height: 0.503,
    transform: "translate(7.484 1.334) rotate(167.333)",
    fill: "#17085e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7366",
    "data-name": "Caminho 7366",
    d: "M1658.531,484.118l-.531-.5s4.329-31.115,6.089-41.449c.642-3.687,2.458-12.066,2.458-12.066l5.558.838s-2.933,7.039-5.167,14.552C1665.206,451.383,1659.564,473.141,1658.531,484.118Z",
    transform: "translate(-1654.801 -375.586)",
    fill: "#d6695d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6568",
    "data-name": "Grupo 6568",
    transform: "translate(2.439 107.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7367",
    "data-name": "Caminho 7367",
    d: "M1656.37,618.8l-.67,1.7,7.346,1.508a9.517,9.517,0,0,0-4.357-2.737,2.216,2.216,0,0,1-2.262-.419Z",
    transform: "translate(-1655.582 -618.8)",
    fill: "#1b0a74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2004",
    "data-name": "Ret\\xE2ngulo 2004",
    width: 7.485,
    height: 0.503,
    transform: "matrix(-0.98, -0.2, 0.2, -0.98, 7.334, 3.683)",
    fill: "#17085e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6583",
    "data-name": "Grupo 6583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6577",
    "data-name": "Grupo 6577",
    transform: "translate(23.969 7.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7368",
    "data-name": "Caminho 7368",
    d: "M1789.016,334a12.435,12.435,0,0,0-.922,4.357l2.681.782,1.508-4.441Z",
    transform: "translate(-1772.526 -314.106)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7369",
    "data-name": "Caminho 7369",
    d: "M1743.663,322.9s10.111,14.8,10.725,18.406c.587,3.6-3.547,5.977-5.586,4.581S1742.462,324.911,1743.663,322.9Z",
    transform: "translate(-1740.357 -306.106)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7370",
    "data-name": "Caminho 7370",
    d: "M1772.338,340.222s-1.48,11.9-3.408,16.9a6.412,6.412,0,0,1-.95,1.788,3.566,3.566,0,0,1-1.257.95,4.342,4.342,0,0,1-4.385-.67,3.474,3.474,0,0,1-1.285-1.76c-.112-.475.307-1.564,1.061-3.1.112-.279.251-.531.391-.838.419-.81.866-1.732,1.369-2.737a67.873,67.873,0,0,0,4.748-11.452c.14.084.279.14.391.223a7.715,7.715,0,0,0,2.709.7Z",
    transform: "translate(-1753.027 -317.925)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7371",
    "data-name": "Caminho 7371",
    d: "M1747.651,346.39a6.551,6.551,0,0,1-1.564,1.313,4.092,4.092,0,0,1-1.536.419c.056.168-.251.112-.2.251-1.313-.2-2.095-.307-2.625-.838-4.329-4.106-14.608-24.356-6.089-24.635h.028c.028.028.056.056.056.084l.028.028.028.028c0,.028.028.028.028.056a36.468,36.468,0,0,1,2.179,3.743c2.709,5.419,2.961,9.692,5.055,13.77a17.91,17.91,0,0,0,2.6,3.771A19.525,19.525,0,0,0,1747.651,346.39Z",
    transform: "translate(-1732.363 -306.106)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6576",
    "data-name": "Grupo 6576",
    transform: "translate(14.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6574",
    "data-name": "Grupo 6574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6569",
    "data-name": "Grupo 6569",
    transform: "translate(1.888 17.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7372",
    "data-name": "Caminho 7372",
    d: "M1794.024,324.286a5.118,5.118,0,0,0-2.6,2.486c-.642,1.033,3.519,2.6,3.91,1.9.279-.084,1.369-.168,1.732-.7a2.757,2.757,0,0,0-.391-3.24A4.5,4.5,0,0,0,1794.024,324.286Z",
    transform: "translate(-1791.359 -324.242)",
    fill: "#fda798"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7373",
    "data-name": "Caminho 7373",
    d: "M1799.592,322.53a2.156,2.156,0,0,1,.419-.056c-.112.168,0,.363.223.391h.056a4.5,4.5,0,0,0,3.575-.978,3.988,3.988,0,0,0,.419-.5l-.642-1.285-.251.335a3.318,3.318,0,0,1-1.871,1.229,16.878,16.878,0,0,1-2.067.391C1799.089,322.083,1799.229,322.586,1799.592,322.53Z",
    transform: "translate(-1795.151 -304.088)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7374",
    "data-name": "Caminho 7374",
    d: "M1803.923,328.795a2.159,2.159,0,0,1,.419-.056.209.209,0,0,0,0,.251.221.221,0,0,0,.223.14,4.547,4.547,0,0,0,3.631-.978c.056-.056.084-.112.14-.168l-.642-1.285a3.208,3.208,0,0,1-1.843,1.2c-.419.112-.866.2-1.313.279a7,7,0,0,1-.754.112C1803.448,328.348,1803.56,328.823,1803.923,328.795Z",
    transform: "translate(-1798.281 -308.845)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7375",
    "data-name": "Caminho 7375",
    d: "M1799.45,332.561c1.061.5,4.078-.112,5.167-.838a7.185,7.185,0,0,0,1.089-.978l-.558-1.145c-.224.2-.419.391-.642.559a3.432,3.432,0,0,1-2.095.866c-.335.028-.7.028-1.033.028-.363,0-.7-.028-1.061-.028a.252.252,0,1,0,0,.5,2.116,2.116,0,0,1,.419.028C1800.595,331.667,1799.254,332.449,1799.45,332.561Z",
    transform: "translate(-1795.288 -310.935)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7376",
    "data-name": "Caminho 7376",
    d: "M1803.291,326.043a2.157,2.157,0,0,1,.419-.056c-.112.168,0,.363.223.391h.112a4.53,4.53,0,0,0,3.436-.922l-.642-1.257a3.082,3.082,0,0,1-1.648.978,16.87,16.87,0,0,1-2.067.391.241.241,0,0,0-.224.251A.365.365,0,0,0,1803.291,326.043Z",
    transform: "translate(-1797.789 -307.043)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7377",
    "data-name": "Caminho 7377",
    d: "M1810.5,326.4a2.579,2.579,0,0,1,.419,3.017A9.471,9.471,0,0,0,1810.5,326.4Z",
    transform: "translate(-1803.266 -308.628)",
    fill: "#fd876d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7378",
    "data-name": "Caminho 7378",
    d: "M1803.759,326.5a1.683,1.683,0,0,1-.559,1.9s.894-.754.95-1.117A.919.919,0,0,0,1803.759,326.5Z",
    transform: "translate(-1798.005 -308.701)",
    fill: "#fd876d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6573",
    "data-name": "Grupo 6573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6570",
    "data-name": "Grupo 6570",
    transform: "translate(4.385 11.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7379",
    "data-name": "Caminho 7379",
    d: "M1806.221,314.011l-2.653.726a.463.463,0,0,1-.559-.307l-2.709-9.552,3.547-.978,2.709,9.552A.47.47,0,0,1,1806.221,314.011Z",
    transform: "translate(-1800.3 -303.9)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7380",
    "data-name": "Caminho 7380",
    d: "M1814.66,309.011l-1.173.335-.586-2.151.754-.2.279,1.061Z",
    transform: "translate(-1809.381 -306.134)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7381",
    "data-name": "Caminho 7381",
    d: "M1813.96,309.211l-1.145.335-.615-2.151.754-.2.279,1.061Z",
    transform: "translate(-1808.876 -306.278)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7382",
    "data-name": "Caminho 7382",
    d: "M1804.35,316.271l-.782.223a.463.463,0,0,1-.559-.307l-2.709-9.552,1.229-.335Z",
    transform: "translate(-1800.3 -305.63)",
    fill: "#d6695d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_648",
    "data-name": "Elipse 648",
    cx: 1.983,
    cy: 1.983,
    r: 1.983,
    transform: "translate(0 9.113)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7383",
    "data-name": "Caminho 7383",
    d: "M1798.682,266.5s-3.408,5.055-11.982,7.122c0,0-.028,3.91,2.179,5.949,0,0,8.994-4.245,14.524-1.676Z",
    transform: "translate(-1786.113 -265.459)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7384",
    "data-name": "Caminho 7384",
    d: "M1786.8,294a.545.545,0,0,0,.028.2C1786.828,294.14,1786.8,294.056,1786.8,294Z",
    transform: "translate(-1786.186 -285.278)",
    fill: "#7c71ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7385",
    "data-name": "Caminho 7385",
    d: "M1797.782,287.9c-.251.112-.531.2-.782.307A6.519,6.519,0,0,1,1797.782,287.9Z",
    transform: "translate(-1793.537 -280.882)",
    fill: "#7c71ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7386",
    "data-name": "Caminho 7386",
    d: "M1800.554,286.7c-.251.112-.5.223-.754.307.251-.084.5-.2.754-.307Z",
    transform: "translate(-1795.555 -280.017)",
    fill: "#7c71ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7387",
    "data-name": "Caminho 7387",
    d: "M1792.079,290.124a27.439,27.439,0,0,1-.894-3.324c-.251.112-.5.223-.754.307-.251.112-.531.2-.782.307-.168.056-.363.14-.559.2-.167.056-.363.112-.531.168-.028,0-.028,0-.056.028-.14.056-.307.084-.447.14-.056.028-.112.028-.168.056-.167.056-.335.084-.5.14a4.461,4.461,0,0,1-.587.14s0,.223.028.559a.545.545,0,0,0,.028.2v.223a.355.355,0,0,0,.028.168c.056.363.112.81.224,1.285.028.084.028.168.056.251,0,.028.028.084.028.112s.028.084.028.112.028.084.028.112.028.084.028.112a6.681,6.681,0,0,0,1.648,2.793,42.778,42.778,0,0,1,4.273-1.536A17.466,17.466,0,0,1,1792.079,290.124Z",
    transform: "translate(-1786.186 -280.089)",
    fill: "#cf3b59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6572",
    "data-name": "Grupo 6572",
    transform: "translate(12.372)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7388",
    "data-name": "Caminho 7388",
    d: "M1833.532,268.47c-.978-2.793-2.346-4.944-3.352-5.419l-.084-.251-.531.168h0c-1.005.363-.866,3.38.307,6.759s2.933,5.81,3.938,5.5h0l.531-.168-.084-.251C1834.761,273.8,1834.51,271.263,1833.532,268.47Z",
    transform: "translate(-1828.894 -262.792)",
    fill: "#cf3b59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7389",
    "data-name": "Caminho 7389",
    d: "M1835.387,268.283c1.173,3.38,1.313,6.4.307,6.759-.782.279-2.067-1.2-3.128-3.463-.279-.615-.559-1.285-.81-2.011s-.447-1.424-.615-2.095c-.587-2.458-.475-4.413.307-4.664C1832.454,262.445,1834.214,264.9,1835.387,268.283Z",
    transform: "translate(-1830.246 -262.773)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6571",
    "data-name": "Grupo 6571",
    transform: "translate(0.895 3.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7390",
    "data-name": "Caminho 7390",
    d: "M1835.284,281.4a2.864,2.864,0,0,0-1.76.5c-.279-.614-.559-1.285-.81-2.011s-.447-1.424-.615-2.095a2.609,2.609,0,0,0,1.676-.7C1834.809,277.575,1835.871,280.424,1835.284,281.4Z",
    transform: "translate(-1832.1 -276.864)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_649",
    "data-name": "Elipse 649",
    cx: 0.67,
    cy: 2.262,
    rx: 0.67,
    ry: 2.262,
    transform: "matrix(0.945, -0.328, 0.328, 0.945, 1.046, 0.439)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7391",
    "data-name": "Caminho 7391",
    d: "M1839.717,281.55c.224.642.251,1.229.056,1.285s-.531-.391-.754-1.061c-.224-.642-.251-1.229-.056-1.285S1839.494,280.907,1839.717,281.55Z",
    transform: "translate(-1836.952 -279.303)",
    fill: "url(#linear-gradient-22)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7392",
    "data-name": "Caminho 7392",
    d: "M1798.313,316.915c.084-.14-.279-.978-.586-.922a5.148,5.148,0,0,0-2.486,1.257,11.148,11.148,0,0,0-1.955,2.877c-.084.2.782-.251.95-.251a.244.244,0,0,0,.251.14c1.061-.112,1.145-1.089,1.788-1.732C1796.972,317.669,1797.894,317.641,1798.313,316.915Z",
    transform: "translate(-1790.855 -301.126)",
    fill: "#fda798"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6575",
    "data-name": "Grupo 6575",
    transform: "translate(7.011 15.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7393",
    "data-name": "Caminho 7393",
    d: "M1811.646,319.548a2.443,2.443,0,0,0,.447-.056,6.6,6.6,0,0,1,1.257-.223l-.14-.14c0-.028,0-.056.028-.056,0-.028.028-.056.028-.084a.869.869,0,0,0-.475-1.089,6,6,0,0,0-1.648.81C1810.948,318.822,1811.255,319.548,1811.646,319.548Z",
    transform: "translate(-1810.697 -317.9)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7394",
    "data-name": "Caminho 7394",
    d: "M1810.4,324.279a6.486,6.486,0,0,0,.866-.307c.2-.084.363-.14.559-.223a1.4,1.4,0,0,1,.95-.056c.028,0,.028,0,.056.028a1.972,1.972,0,0,0-.251-.251h0a.868.868,0,0,0,.056-.223,1.145,1.145,0,0,0-.279-.95l-.14-.14c0-.028,0-.056.028-.056a4.191,4.191,0,0,0-1.061.419h0c-.028,0-.028.028-.056.028a4.466,4.466,0,0,0-1.4,1.033C1809.589,323.72,1810.008,324.362,1810.4,324.279Z",
    transform: "translate(-1809.702 -320.927)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7395",
    "data-name": "Caminho 7395",
    d: "M1815.2,326.926c.2-.084.363-.14.559-.223a1.4,1.4,0,0,1,.95-.056c.028,0,.028,0,.056.028a1.953,1.953,0,0,0-.251-.251h0a.862.862,0,0,0,.056-.223A6.5,6.5,0,0,0,1815.2,326.926Z",
    transform: "translate(-1813.664 -323.882)",
    fill: "#fd876d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7396",
    "data-name": "Caminho 7396",
    d: "M1813.1,322.359l.5-.084h0s.531-.2,1.061-.335c0-.028,0-.056.028-.056,0-.028.028-.056.028-.084C1814.022,322,1813.1,322.359,1813.1,322.359Z",
    transform: "translate(-1812.151 -320.711)",
    fill: "#fd876d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7397",
    "data-name": "Caminho 7397",
    d: "M1812.746,328.871c.028,0,.056.028.084.028h.084a12.835,12.835,0,0,0,1.4-.363c.028,0,.056-.028.084-.028.2-.028.391-.223.363-.251a.027.027,0,0,1-.028-.028,1,1,0,0,0,.056-.475.832.832,0,0,0-.2-.5,1.967,1.967,0,0,0-.251-.251,4.545,4.545,0,0,0-.782.307,6.789,6.789,0,0,0-1.285.782C1812.1,328.285,1812.383,328.76,1812.746,328.871Z",
    transform: "translate(-1811.518 -324.458)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7398",
    "data-name": "Caminho 7398",
    d: "M1813.9,330.961l.028.028c.028,0,.056.028.084.028a1.422,1.422,0,0,0,.754-.112,6.287,6.287,0,0,0,.726-.251,1.185,1.185,0,0,0,.14-.056h0a1.736,1.736,0,0,1,.279-.223,1,1,0,0,0,.056-.475,2.764,2.764,0,0,0-.922.642A3.883,3.883,0,0,1,1813.9,330.961Z",
    transform: "translate(-1812.727 -326.548)",
    fill: "#fd876d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7399",
    "data-name": "Caminho 7399",
    d: "M1816.7,332.808a2.632,2.632,0,0,0,.866-.2h0a1,1,0,0,0,.2-1.033,2.517,2.517,0,0,0-.14-.279c-.112.056-.224.084-.335.14h0c-.028,0-.028.028-.056.028a5,5,0,0,0-.978.587C1816.087,332.25,1816.311,332.808,1816.7,332.808Z",
    transform: "translate(-1814.384 -327.557)",
    fill: "#fda798"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7400",
    "data-name": "Caminho 7400",
    d: "M1723.269,300.533c-.112.2-.224.391-.307.559a10.309,10.309,0,0,0-.559,1.452c-.14.475-.251.95-.335,1.369a11.73,11.73,0,0,0-.251,2.4c-4.134,1.424-8.016-1.76-8.016-1.76a17.082,17.082,0,0,0,.7-1.843,31.641,31.641,0,0,0,.754-3.1c0-.028,0-.056.028-.056V299.5Z",
    transform: "translate(-1695.016 -281.463)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7401",
    "data-name": "Caminho 7401",
    d: "M1725.07,300.533c-.112.2-.223.391-.307.559a6.685,6.685,0,0,0-.559,1.452c-.14.475-.363,1.564-.447,1.983a8.822,8.822,0,0,1-5.447-.5,5.426,5.426,0,0,1-2.011-1.313,31.666,31.666,0,0,0,.754-3.1c0-.028,0-.056.028-.056V299.5Z",
    transform: "translate(-1696.818 -281.463)",
    fill: "#fd876d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7402",
    "data-name": "Caminho 7402",
    d: "M1704,348.506c-1.9,1.7-7.848,1.117-12.764.251-1.369-.223-2.626-.5-3.715-.726h-.056c-1.927-.419-3.268-.754-3.436-.81H1684v-.028c.587-2.961,1.089-9.273,1.48-15.362.2-2.961.335-5.837.447-8.3.2-3.827.279-6.536.279-6.536h.028c2.123-1.257,6.005-3.1,6.005-3.1.14.14.279.251.391.363,3.575,3.156,6.647,2.625,7.709,2.29l.419-.14a4.319,4.319,0,0,1,.978,1.229l.028.028c.028.056.056.084.056.14h0a10.324,10.324,0,0,1,.894,2.625c.112.531.2,1.061.279,1.648a52.569,52.569,0,0,1,.251,6.564c-.028,2.179.056,5.335.2,8.463.056,1.676.14,3.324.223,4.86.028.838.084,1.62.112,2.318,0,.168.028.335.028.5C1703.915,347,1704,348.506,1704,348.506Z",
    transform: "translate(-1673.539 -291.841)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7403",
    "data-name": "Caminho 7403",
    d: "M1681.37,335.909s-1.564,20.864-2.57,23.629c0,0,5.279-1.173,8.687-.475,0,0-3.547-12.569-2.095-17.652,2.821-9.8-2.178-13.211-2.178-13.211S1682.627,333.758,1681.37,335.909Z",
    transform: "translate(-1669.791 -302.147)",
    fill: "#312da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7404",
    "data-name": "Caminho 7404",
    d: "M1663.5,334.005h0s-2.234,2.737-4.664,5.7c-.307.363-.587.726-.894,1.089-1.76,2.179-3.519,4.329-4.469,5.53-.363.447-.587.754-.7.894-.224.279-2.542-.14-4.05-.838-.782-.363-1.369-.81-1.257-1.257a49.209,49.209,0,0,1,8.994-17.205h0a14.367,14.367,0,0,1,3.436-3.016h.028C1664.475,327.609,1663.525,333.81,1663.5,334.005Z",
    transform: "translate(-1647.198 -299.769)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6579",
    "data-name": "Grupo 6579",
    transform: "translate(8.646 58.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6578",
    "data-name": "Grupo 6578",
    transform: "translate(0 0.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7405",
    "data-name": "Caminho 7405",
    d: "M1682.251,446.008h0a4.844,4.844,0,0,0-.335-.391h0a3.557,3.557,0,0,0-2.123-1.089h0c-.084,0-.168-.028-.251-.028a2.36,2.36,0,0,0-1.285.363,1.628,1.628,0,0,0-.67,1.006h0a3.538,3.538,0,0,0,.028,1.62c.167.894.5,2.29,1.424,2.681a.489.489,0,0,0,.671-.447.858.858,0,0,0,.782.168.658.658,0,0,0,.5-.5.675.675,0,0,0,.978.028.731.731,0,0,0,.251-.5.769.769,0,0,0,.95-.084C1684.066,448.131,1682.726,446.623,1682.251,446.008Z",
    transform: "translate(-1677.504 -444.5)",
    fill: "#fda798"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7406",
    "data-name": "Caminho 7406",
    d: "M1687.667,442.757a6.239,6.239,0,0,0-2.374.391.027.027,0,0,0-.028.028.533.533,0,0,0-.223.95c.475.391,1.061.81,1.62.67.307-.084.559-.642.894-.614.419.028.782.5,1.033.81.447.559,1.452.223,1.089-.363C1689.286,443.9,1688.5,442.869,1687.667,442.757Z",
    transform: "translate(-1682.78 -442.741)",
    fill: "#fda798"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7407",
    "data-name": "Caminho 7407",
    d: "M1657.473,407.849l-.14.112-1.955,1.4h0l-.363.251-.838-1.117a104.156,104.156,0,0,1-5.921-8.631c-1.173-2.4-1.983-3.994-1.341-5.083a2.006,2.006,0,0,1,1.816-.978,6.415,6.415,0,0,1,3.8,1.7,3.944,3.944,0,0,1,.391.475,36.45,36.45,0,0,1,2.961,6.927c.223.642.419,1.257.614,1.816v.028a.71.71,0,0,1,.056.2C1657.11,406.648,1657.473,407.849,1657.473,407.849Z",
    transform: "translate(-1646.649 -349.424)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6582",
    "data-name": "Grupo 6582",
    transform: "translate(16.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7408",
    "data-name": "Caminho 7408",
    d: "M1720.673,264.361s-.251,4.273,1.061,5.391,6.089,1.871,7.43.726c2.262-1.9,3.855-11.507,3.6-12.429-.224-.922-6.731-5.558-9.887-2.625C1719.751,258.384,1720.673,264.361,1720.673,264.361Z",
    transform: "translate(-1716.37 -249.005)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7409",
    "data-name": "Caminho 7409",
    d: "M1724.017,240.642c.978-1.843.7-4.162-2.095-4.329-.419-.028-.95.251-1.313.2-.307-.056-.642-.5-1.117-.587a2.252,2.252,0,0,0-1.648.223c-1.452-1.676-4.636-1.732-5.419.475a2.218,2.218,0,0,0-2.374.14,1.911,1.911,0,0,0-.782,1.7,1.613,1.613,0,0,0-1.369,1.117,2.605,2.605,0,0,0-.056,1.313,2.589,2.589,0,0,0-2.039,1.843,2.99,2.99,0,0,0,.307,2.4,2.143,2.143,0,0,0-.2,2.039,2.06,2.06,0,0,0,1.369,1.313,4.2,4.2,0,0,0,.167,2.57c.335,1.173,2.123,2.793,2.709,2.653.391-1.843,1.48-7.9,1.257-10.642a53.67,53.67,0,0,0,7.932.14c1.62.894,3.519,1.592,4.72.978C1725.86,243.3,1725.3,241.452,1724.017,240.642Z",
    transform: "translate(-1705.664 -234.922)",
    fill: "#1b0a74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7410",
    "data-name": "Caminho 7410",
    d: "M1709.784,251.615c-1.061-.614-.251-2.095.587-3.017a3.7,3.7,0,0,1-1.452-.7,1.631,1.631,0,0,0-1.117,1.061,2.607,2.607,0,0,0-.056,1.313,2.589,2.589,0,0,0-2.039,1.843,2.991,2.991,0,0,0,.307,2.4,2.143,2.143,0,0,0-.2,2.039,2.061,2.061,0,0,0,1.369,1.313,4.2,4.2,0,0,0,.168,2.57c.335,1.173,2.123,2.793,2.709,2.653a74.409,74.409,0,0,0,1.257-8.826C1710.231,253.821,1709.142,252.676,1709.784,251.615Z",
    transform: "translate(-1705.592 -244.275)",
    fill: "#17085e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6580",
    "data-name": "Grupo 6580",
    transform: "translate(2.582 11.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7411",
    "data-name": "Caminho 7411",
    d: "M1717.843,276.74c-.391-.615-2.346-1.648-2.793-.866-.7,1.257.363,4.162,2.514,3.519C1718.373,279.142,1718.178,277.271,1717.843,276.74Z",
    transform: "translate(-1714.836 -275.593)",
    fill: "#fda798"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7412",
    "data-name": "Caminho 7412",
    d: "M1719.365,279.881s-1.313-1.313-1.564-.894c-.475.838.643,1.815.978,2.039,0,0-.531-.922-.279-1.2S1719.365,279.881,1719.365,279.881Z",
    transform: "translate(-1716.89 -277.98)",
    fill: "#fd876d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7419",
    "data-name": "Caminho 7419",
    d: "M1654.075,366.691c-1.648-2.234-5.251-7.178-5.949-8.631-1.173-2.4-2.011-3.994-1.341-5.055a49.1,49.1,0,0,1,8.966-17.205c-.112.251-5.363,11.647-7.15,16.228a13.845,13.845,0,0,0-.586,1.7,1.312,1.312,0,0,0,.028.559C1648.545,357.167,1654.075,366.691,1654.075,366.691Z",
    transform: "translate(-1646.547 -307.624)",
    fill: "#312da4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7420",
    "data-name": "Caminho 7420",
    d: "M1686.978,457.926h0a.745.745,0,0,1-.14.168c-.782.838-3.826,1.927-5,1.369s-2.011-1.48-2.039-4.553c0,0,2.709.251,5.307-2.709a2.245,2.245,0,0,1,1.732,1.788C1687.006,455.356,1687.537,457.032,1686.978,457.926Z",
    transform: "translate(-1670.512 -391.513)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7421",
    "data-name": "Caminho 7421",
    d: "M1686.978,464.917a.745.745,0,0,1-.14.168c-.782.838-3.826,1.927-5,1.369s-2.011-1.48-2.039-4.553C1679.828,461.9,1680.945,467.933,1686.978,464.917Z",
    transform: "translate(-1670.512 -398.504)",
    fill: "#d6695d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6594",
    "data-name": "Grupo 6594",
    transform: "translate(1568.131 75.659)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6587",
    "data-name": "Grupo 6587",
    transform: "translate(38.273 10.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7423",
    "data-name": "Caminho 7423",
    d: "M2006.289,95.054l-3.324,5.055a.507.507,0,0,1-.726.14l-5.447-3.575a.507.507,0,0,1-.14-.726l3.324-5.055a.507.507,0,0,1,.726-.14l5.447,3.575A.507.507,0,0,1,2006.289,95.054Z",
    transform: "translate(-1996.557 -90.657)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7424",
    "data-name": "Caminho 7424",
    d: "M2004.613,108.351l-1.648,2.514a.507.507,0,0,1-.726.14l-5.447-3.575a.507.507,0,0,1-.14-.726l.475-.7,1.648-.419a.257.257,0,0,1,.307.2l.391,2.123a.257.257,0,0,0,.307.2l4.441-1.117a.245.245,0,0,1,.307.223Z",
    transform: "translate(-1996.557 -101.413)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_650",
    "data-name": "Elipse 650",
    cx: 0.922,
    cy: 0.922,
    r: 0.922,
    transform: "translate(3.671 1.66)",
    fill: "url(#linear-gradient-29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6588",
    "data-name": "Grupo 6588",
    transform: "translate(0.32 21.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7425",
    "data-name": "Caminho 7425",
    d: "M1870.763,128.348l1.285,8.044a.7.7,0,0,1-.587.81l-8.687,1.369a.7.7,0,0,1-.81-.587l-1.285-8.044a.7.7,0,0,1,.587-.81l8.687-1.369A.682.682,0,0,1,1870.763,128.348Z",
    transform: "translate(-1860.672 -127.747)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7426",
    "data-name": "Caminho 7426",
    d: "M1874.308,141.431l.642,3.966a.7.7,0,0,1-.586.81l-8.687,1.369a.7.7,0,0,1-.81-.587l-.168-1.117,1.257-1.927a.329.329,0,0,1,.475-.084l2.318,1.76a.329.329,0,0,0,.475-.084l3.38-5.111a.334.334,0,0,1,.5-.056Z",
    transform: "translate(-1863.575 -136.779)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_651",
    "data-name": "Elipse 651",
    cx: 1.229,
    cy: 1.229,
    r: 1.229,
    transform: "translate(2.103 2.221)",
    fill: "url(#linear-gradient-32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6589",
    "data-name": "Grupo 6589",
    transform: "translate(32.803 29.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7427",
    "data-name": "Caminho 7427",
    d: "M1980.025,165.459l-1.564-.279a.735.735,0,0,0-.81.559l-.67,3.994a.719.719,0,0,0,.559.81l1.564.279a.735.735,0,0,0,.81-.559l.67-3.994A.7.7,0,0,0,1980.025,165.459Z",
    transform: "translate(-1976.972 -162.832)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7428",
    "data-name": "Caminho 7428",
    d: "M1996.425,162.521a.77.77,0,0,0-.559-.866.821.821,0,0,0,.5-.587.81.81,0,0,0-.642-.922l-1.285-.223a2.253,2.253,0,0,0,.782-.614c.615-.866.363-2.458-.335-2.514s-.642,1.117-1.341,1.285a10.154,10.154,0,0,0-3.827,1.927c-.028,0-.056.028-.084.028l-.838,4.888,2.458.419.419.084,2.625.447a.81.81,0,0,0,.922-.642.72.72,0,0,0-.251-.7.788.788,0,0,0,.894-.642.727.727,0,0,0-.279-.726A.819.819,0,0,0,1996.425,162.521Z",
    transform: "translate(-1985.496 -156.793)",
    fill: "url(#linear-gradient-34)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6590",
    "data-name": "Grupo 6590",
    transform: "translate(15.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7429",
    "data-name": "Caminho 7429",
    d: "M1914.763,76.474l-.866,1.313a.679.679,0,0,0,.2.95l3.38,2.234a.679.679,0,0,0,.95-.2l.866-1.313a.679.679,0,0,0-.2-.95l-3.38-2.234A.657.657,0,0,0,1914.763,76.474Z",
    transform: "translate(-1913.779 -69.312)",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7430",
    "data-name": "Caminho 7430",
    d: "M1923.4,52.843a.812.812,0,0,0-1.033.14.847.847,0,0,0-.335-.7.772.772,0,0,0-1.089.223l-.726,1.089a2.373,2.373,0,0,0-.251-.95c-.559-.894-2.095-1.313-2.43-.7s.754,1.033.642,1.76a9.8,9.8,0,0,0,.251,4.273v.084l4.162,2.737,1.369-2.095.224-.363,1.452-2.234a.772.772,0,0,0-.223-1.089.836.836,0,0,0-.726-.056.8.8,0,0,0-.223-1.089.74.74,0,0,0-.754-.056A.81.81,0,0,0,1923.4,52.843Z",
    transform: "translate(-1916.439 -51.659)",
    fill: "url(#linear-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7431",
    "data-name": "Caminho 7431",
    d: "M1949.734,108.833c-1.536-2.151-4.385.168-4.525,1.424v0c-.754-1.006-4.413-1.536-4.636,1.089-.307,3.491,6.229,4.72,6.229,4.72S1951.773,111.682,1949.734,108.833Z",
    transform: "translate(-1917.929 -92.231)",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7432",
    "data-name": "Caminho 7432",
    d: "M1871.474,248.075c-.531-3.212-4.916-2.207-5.781-.894v0c-.279-1.536-3.994-4.106-5.7-1.341-2.234,3.659,4.273,8.575,4.273,8.575S1872.173,252.321,1871.474,248.075Z",
    transform: "translate(-1859.528 -190.722)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6592",
    "data-name": "Grupo 6592",
    transform: "translate(12.366 35.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7433",
    "data-name": "Caminho 7433",
    d: "M1912.682,198.469,1903.8,197.3l.866-6.4,8.854,1.2Z",
    transform: "translate(-1903.8 -187.832)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7434",
    "data-name": "Caminho 7434",
    d: "M1915.682,184.185l-8.882-1.173,4.609-3.017a.469.469,0,0,1,.615.084Z",
    transform: "translate(-1905.962 -179.917)",
    fill: "#cf3b59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7435",
    "data-name": "Caminho 7435",
    d: "M1915.438,196.694l-5.838-.782.838-6.312,5.838.782Z",
    transform: "translate(-1907.98 -186.895)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6591",
    "data-name": "Grupo 6591",
    transform: "translate(2.737 3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7436",
    "data-name": "Caminho 7436",
    d: "M1914.6,192.14l4.581.614.028-.14-4.581-.614Z",
    transform: "translate(-1914.321 -192)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7437",
    "data-name": "Caminho 7437",
    d: "M1914.3,194.04l4.609.614v-.14l-4.581-.614Z",
    transform: "translate(-1914.104 -193.369)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7438",
    "data-name": "Caminho 7438",
    d: "M1914.1,195.94l4.581.614.028-.14-4.581-.614Z",
    transform: "translate(-1913.96 -194.739)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7439",
    "data-name": "Caminho 7439",
    d: "M1913.8,197.84l4.609.614v-.14l-4.581-.614Z",
    transform: "translate(-1913.744 -196.108)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7440",
    "data-name": "Caminho 7440",
    d: "M1913.6,199.74l4.581.614.028-.14-4.581-.614Z",
    transform: "translate(-1913.6 -197.477)",
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7441",
    "data-name": "Caminho 7441",
    d: "M1912.682,201.568,1903.8,200.4l9.72-5.2Z",
    transform: "translate(-1903.8 -190.931)",
    fill: "#cf3b59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7442",
    "data-name": "Caminho 7442",
    d: "M1912.682,198.469,1903.8,197.3l.866-6.4Z",
    transform: "translate(-1903.8 -187.832)",
    fill: "url(#linear-gradient-46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6593",
    "data-name": "Grupo 6593",
    transform: "translate(20.214 49.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7443",
    "data-name": "Caminho 7443",
    d: "M1943.77,235.059v-1.648l-1.2-.363a5.387,5.387,0,0,0-.531-1.313l.587-1.117-1.173-1.173-1.117.587a4.181,4.181,0,0,0-1.313-.531l-.363-1.2h-1.648l-.363,1.2a5.392,5.392,0,0,0-1.313.531l-1.117-.587-1.173,1.173.586,1.117a4.189,4.189,0,0,0-.531,1.313l-1.2.363v1.648l1.2.363a5.4,5.4,0,0,0,.531,1.313l-.586,1.117,1.173,1.173,1.117-.587a4.186,4.186,0,0,0,1.313.531l.363,1.2h1.648l.363-1.2a5.388,5.388,0,0,0,1.313-.531l1.117.587,1.173-1.173-.587-1.117a4.181,4.181,0,0,0,.531-1.313Zm-5.949,2.709a3.519,3.519,0,1,1,3.519-3.519A3.541,3.541,0,0,1,1937.821,237.769Z",
    transform: "translate(-1931.9 -228.3)",
    fill: "url(#linear-gradient-47)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6595",
    "data-name": "Grupo 6595",
    transform: "translate(1541.757 156.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7444",
    "data-name": "Caminho 7444",
    d: "M1767.921,428.7l7.457,2.039s.224,5.167-1.787,8.575c0,0-7.178.14-8.491-.2C1765.071,439.118,1768.619,432.415,1767.921,428.7Z",
    transform: "translate(-1765.099 -428.7)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7445",
    "data-name": "Caminho 7445",
    d: "M1784.681,435.124l.084-.251a40.643,40.643,0,0,0-4.609-1.173l-.056.251A35.333,35.333,0,0,1,1784.681,435.124Z",
    transform: "translate(-1775.91 -432.303)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7446",
    "data-name": "Caminho 7446",
    d: "M1784.081,438.924l.084-.251a40.671,40.671,0,0,0-4.609-1.173l-.056.251A39.4,39.4,0,0,1,1784.081,438.924Z",
    transform: "translate(-1775.478 -435.042)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7447",
    "data-name": "Caminho 7447",
    d: "M1782.581,448.124l.084-.251a40.639,40.639,0,0,0-4.609-1.173l-.056.251A39.4,39.4,0,0,1,1782.581,448.124Z",
    transform: "translate(-1774.397 -441.672)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7448",
    "data-name": "Caminho 7448",
    d: "M1781.648,452.817l.056-.251a47.436,47.436,0,0,0-4.776-.866l-.028.251A38.942,38.942,0,0,1,1781.648,452.817Z",
    transform: "translate(-1773.604 -445.276)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7449",
    "data-name": "Caminho 7449",
    d: "M1779.964,458.592l.028-.251a27.4,27.4,0,0,0-4.692-.223l.028.251A26.553,26.553,0,0,1,1779.964,458.592Z",
    transform: "translate(-1772.451 -449.878)",
    fill: "#becef5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6596",
    "data-name": "Grupo 6596",
    transform: "translate(1571.643 148.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7450",
    "data-name": "Caminho 7450",
    d: "M1877.91,397.5l-5.81,9.776s5.055,5.7,10.642,7.29c0,0,7.737-7.178,8.8-8.91C1891.54,405.656,1880.954,402.164,1877.91,397.5Z",
    transform: "translate(-1872.1 -397.5)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7451",
    "data-name": "Caminho 7451",
    d: "M1879.735,414.089l-.335-.168a57.562,57.562,0,0,1,3.687-5.921l.307.223A49.4,49.4,0,0,0,1879.735,414.089Z",
    transform: "translate(-1877.361 -405.067)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7452",
    "data-name": "Caminho 7452",
    d: "M1884.235,417.689l-.335-.168a57.609,57.609,0,0,1,3.687-5.921l.307.223A49.414,49.414,0,0,0,1884.235,417.689Z",
    transform: "translate(-1880.604 -407.662)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7453",
    "data-name": "Caminho 7453",
    d: "M1895.135,425.889l-.335-.168a57.586,57.586,0,0,1,3.687-5.921l.307.223A59.3,59.3,0,0,0,1895.135,425.889Z",
    transform: "translate(-1888.46 -413.571)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7454",
    "data-name": "Caminho 7454",
    d: "M1899.707,429.705l-.307-.2c.028-.028,2.067-3.24,4.162-5.81l.279.251C1901.774,426.493,1899.735,429.677,1899.707,429.705Z",
    transform: "translate(-1891.775 -416.382)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7455",
    "data-name": "Caminho 7455",
    d: "M1906.007,434.151l-.307-.223a41.077,41.077,0,0,1,4.748-5.028l.251.279A42.732,42.732,0,0,0,1906.007,434.151Z",
    transform: "translate(-1896.315 -420.13)",
    fill: "#becef5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6599",
    "data-name": "Grupo 6599",
    transform: "translate(1553.125 181.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6598",
    "data-name": "Grupo 6598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6597",
    "data-name": "Grupo 6597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7456",
    "data-name": "Caminho 7456",
    d: "M1815.8,519.51s2.011,8.016,2.011,11.843c0,0,16.144-.279,22.456,0,0,0-.419-7.849-.642-12.653C1839.625,518.7,1821.833,519.789,1815.8,519.51Z",
    transform: "translate(-1813.007 -517.918)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7457",
    "data-name": "Caminho 7457",
    d: "M1808.593,519.726A6.377,6.377,0,0,1,1805.8,519s1.648,10.251,1.453,12.345l3.352.223S1810.52,524.335,1808.593,519.726Z",
    transform: "translate(-1805.8 -518.134)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7458",
    "data-name": "Caminho 7458",
    d: "M1888.679,542.7s-1.787.279-5.279.5a38.069,38.069,0,0,0,5.307.223Z",
    transform: "translate(-1861.726 -535.215)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7459",
    "data-name": "Caminho 7459",
    d: "M1875.659,527a34.045,34.045,0,0,1-9.859,2.011s5.5.14,10.055,0Z",
    transform: "translate(-1849.042 -523.9)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7460",
    "data-name": "Caminho 7460",
    d: "M1821.94,548.929s5.642-.2,7.429-.531l-7.569-.7Z",
    transform: "translate(-1817.331 -538.818)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7461",
    "data-name": "Caminho 7461",
    d: "M1807.8,532a6.934,6.934,0,0,0,2.514,1.257l-2.374-.084Z",
    transform: "translate(-1807.241 -527.503)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7462",
    "data-name": "Caminho 7462",
    d: "M1813.7,555.64l2.542.838-.084-.978A5.375,5.375,0,0,1,1813.7,555.64Z",
    transform: "translate(-1811.494 -544.439)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7463",
    "data-name": "Caminho 7463",
    d: "M1805.8,516.766s12.038.112,23.015-.866c0,0,.978.251,3.6.754,0,0-16,1.117-23.825.81C1808.593,517.492,1808.007,517.716,1805.8,516.766Z",
    transform: "translate(-1805.8 -515.9)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6600",
    "data-name": "Grupo 6600",
    transform: "translate(1543.629 194.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7464",
    "data-name": "Caminho 7464",
    d: "M1814.7,565.983h-41.058L1772.5,564h43.349Z",
    transform: "translate(-1772.305 -564)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7465",
    "data-name": "Caminho 7465",
    d: "M1772.834,589.9H1771.8l1.983-18.8h2.178Z",
    transform: "translate(-1771.8 -569.117)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7466",
    "data-name": "Caminho 7466",
    d: "M1779.162,574.117l-2.262,2.262.559-5.279h2.178Z",
    transform: "translate(-1775.475 -569.117)",
    fill: "#8fabec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7467",
    "data-name": "Caminho 7467",
    d: "M1791.933,589.9H1790.9l1.983-18.8h2.179Z",
    transform: "translate(-1785.565 -569.117)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7468",
    "data-name": "Caminho 7468",
    d: "M1915.128,589.9h1.033l-1.983-18.8H1912Z",
    transform: "translate(-1872.841 -569.117)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7469",
    "data-name": "Caminho 7469",
    d: "M1912.363,573.5l2.178,1.061-.363-3.463H1912Z",
    transform: "translate(-1872.841 -569.117)",
    fill: "#8fabec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7470",
    "data-name": "Caminho 7470",
    d: "M1897.428,589.9h1.033l-1.983-18.8H1894.3Z",
    transform: "translate(-1860.085 -569.117)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7471",
    "data-name": "Caminho 7471",
    d: "M1798.534,573.753l-2.234,1.676.475-4.329h2.178Z",
    transform: "translate(-1789.457 -569.117)",
    fill: "#8fabec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7472",
    "data-name": "Caminho 7472",
    d: "M1894.579,572.915l2.262,1.648-.363-3.463H1894.3Z",
    transform: "translate(-1860.085 -569.117)",
    fill: "#8fabec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6601",
    "data-name": "Grupo 6601",
    transform: "translate(1558.767 166.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7473",
    "data-name": "Caminho 7473",
    d: "M1837.088,461.3l9.469,7.932s-3.128,7.653-8.323,11.284c0,0-10.53-4.609-12.234-5.977C1826.028,474.567,1835.636,467.193,1837.088,461.3Z",
    transform: "translate(-1826 -461.3)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7474",
    "data-name": "Caminho 7474",
    d: "M1874.938,477.083l.279-.307a60.336,60.336,0,0,0-5.893-4.776l-.223.335A66.284,66.284,0,0,1,1874.938,477.083Z",
    transform: "translate(-1857.062 -469.011)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7475",
    "data-name": "Caminho 7475",
    d: "M1871.537,482.283l.279-.307a60.3,60.3,0,0,0-5.893-4.776l-.223.335A61.882,61.882,0,0,1,1871.537,482.283Z",
    transform: "translate(-1854.611 -472.759)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7476",
    "data-name": "Caminho 7476",
    d: "M1863.238,494.683l.279-.307a60.32,60.32,0,0,0-5.893-4.776l-.223.335A61.885,61.885,0,0,1,1863.238,494.683Z",
    transform: "translate(-1848.63 -481.696)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7477",
    "data-name": "Caminho 7477",
    d: "M1858.64,500.7l.251-.335a76.247,76.247,0,0,0-6.368-4.469l-.223.363A74.417,74.417,0,0,1,1858.64,500.7Z",
    transform: "translate(-1844.954 -486.236)",
    fill: "#becef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7478",
    "data-name": "Caminho 7478",
    d: "M1852.392,508.2l.224-.335a46.209,46.209,0,0,0-6.676-3.463l-.14.391A41.388,41.388,0,0,1,1852.392,508.2Z",
    transform: "translate(-1840.27 -492.362)",
    fill: "#becef5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7479",
    "data-name": "Caminho 7479",
    d: "M1606.668,638.859H1455.479a.279.279,0,1,1,0-.559h151.189a.279.279,0,0,1,0,.559Z",
    transform: "translate(0 -422.788)",
    fill: "#4d4d4d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignsexecutedcorrectly);
export default __webpack_public_path__ + "static/media/Campaigns executed correctly.29a8e9c1.svg";
export { ForwardRef as ReactComponent };